// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T22:58:43.343Z
// Property: Deer Creek Apartment Homes (ID: 6767906449167599)
// Collections: 35 amenities, 9 floorplans (live), 37 photos, 77 POIs, 9 reviews, 9 virtual tours, 6 office hours, 17 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167599",
  "property_external_id": "1124099",
  "property_zillow_url": "https://www.zillow.com/apartments/overland-park-ks/deer-creek/5Xk6jD/",
  "property_apartments_url": "https://www.apartments.com/deer-creek-apartment-homes-overland-park-ks/6yt2mjs/",
  "property_google_business_url": "https://www.google.com/maps/place/Deer+Creek+Apartment+Homes/@38.8958035,-94.6663844,890m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87c0ea0ac6905893:0xaa04f6836409b405!8m2!3d38.8958035!4d-94.6663844!16s%2Fg%2F1tnqhj1g?entry=ttu&g_ep=EgoyMDI2MDkxNC4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "1124099 p1099051",
  "property_status": null,
  "property_slug": "deer-creek-apartment-homes",
  "property_name": "Deer Creek Apartment Homes",
  "property_website_url": "https://www.deercreekaptskc.com/",
  "property_domain": "https://www.deercreekaptskc.com/",
  "property_address": "12849 Metcalf Ave",
  "property_full_address": "12849 Metcalf Ave, Overland Park, KS 66209",
  "property_address_1": "12849 Metcalf Ave",
  "property_address_2": null,
  "property_address_city": "Overland Park",
  "property_address_state": "KS",
  "property_address_zip_full": null,
  "property_address_zip": "66209",
  "property_address_country": "US",
  "property_address_county": "Johnson County",
  "property_neighborhood_address": "Deer Creek",
  "property_address_latitude": "38.8958329",
  "property_address_longitude": "-94.6663166",
  "property_email": "rentcafe.dc@pricekc.com",
  "property_phone": "(913) 937-3274",
  "property_call_tracking_phone": "913-937-3274",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Craftsman-inspired comfort in Overland Park.</strong> Deer Creek Apartment Homes pairs polished one-, two-, and three-bedroom layouts with serviced-community ease and resort-style spaces—schedule a tour to see how refined South Overland Park living comes together.</p>",
  "property_long_description": "<p>Deer Creek Apartment Homes is a gated apartment community on Metcalf Avenue between 127th and 135th Streets in Overland Park, KS. The community is managed by Price Brothers Management, a Kansas City family-owned company since 1922.</p><p>Residents at Deer Creek spend summer afternoons at the resort-style pool with its waterfall and loggia, take complimentary fitness classes, and walk the nature path that winds through the community. Corbin Park and Town Center Plaza are a short drive away for shopping and dining.</p><p>Explore our floor plans, take a virtual tour, or schedule a visit to see Deer Creek for yourself.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a1a1da-b997-7639-97d7-95d976862277.webp",
  "property_featured_image_media": {
    "alt_text": "Covered outdoor patio with stone fireplace, seating area, and dining table.",
    "public_id": "01a1a1da-b997-7639-97d7-95d976862277",
    "storage_key": "property/6767906449167599/01a1a1da-b997-7639-97d7-95d976862277.webp",
    "width": 1920,
    "height": 1080
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "404",
  "property_year_built": "2002",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.3069306930693",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $175-375",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.",
  "property_pet_policy_description": "The non-refundable fee is $300 for 1 pet, and $500 for 2 pets.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://deercreekaptskc.securecafeapplicant.com/onlineleasing/content3/access/deer-creek2/floorplans",
  "property_resident_portal_url": "https://deercreekaptskc.securecafe.com/residentservices/deer-creek2/userlogin.aspx",
  "property_apply_now_url": "https://deercreekaptskc.securecafeapplicant.com/onlineleasing/content3/access/deer-creek2/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97b-29b9-7538-a268-b1032d95ba7d.webp",
  "property_primary_logo_media": {
    "alt_text": "Deer Creek apartment homes logo",
    "public_id": "019fc97b-29b9-7538-a268-b1032d95ba7d",
    "storage_key": "property/6767906449167599/019fc97b-29b9-7538-a268-b1032d95ba7d.webp",
    "width": 276,
    "height": 150
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97c-2612-776c-abfa-737b77fcf2d9.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019fc97c-2612-776c-abfa-737b77fcf2d9",
    "storage_key": "property/6767906449167599/019fc97c-2612-776c-abfa-737b77fcf2d9.webp",
    "width": 276,
    "height": 150
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97c-19f6-74b8-957e-3c5699e4518f.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019fc97c-19f6-74b8-957e-3c5699e4518f",
    "storage_key": "property/6767906449167599/019fc97c-19f6-74b8-957e-3c5699e4518f.webp",
    "width": 276,
    "height": 150
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#452318",
  "property_secondary_color": "#535435",
  "property_font_color": null,
  "property_color_4": "#B1783A",
  "property_color_3": "#974311",
  "property_color_5": "#C9C7A3",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "672 - 1393",
  "property_sqft_min": "672",
  "property_sqft_max": "1393",
  "property_price_range": "1433 - 7910",
  "property_price_min": "1433",
  "property_price_max": "7910",
  "property_available_units": 23,
  "property_facebook_url": "https://www.facebook.com/DeerCreekAptsKC",
  "property_instagram_url": "https://www.instagram.com/deercreekapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJk1iQxgrqwIcRBbQJZIP2BKo",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Deer Creek Apartment Homes",
  "property_home_romance_title": "Embrace a Life of Comfort and Connection Here",
  "property_home_amenities_blurb": "<p>Deer Creek has a fitness center with a personal trainer and complimentary classes, a clubhouse with floor-to-ceiling windows and a coffee station, concierge services, a car wash station, and a business center. Detached garages are also available.</p>",
  "property_home_floorplans_blurb": "<p>Every apartment at Deer Creek has nine-foot ceilings, a fully equipped open kitchen, a formal dining room, an in-unit washer and dryer, a large garden tub, spacious closets, and a private patio or balcony with atrium doors. Select homes add an attached garage, a kitchen island, granite countertops, coffered ceilings, a library niche, a mudroom, or a den.</p>",
  "property_home_gallery_blurb": "<p><strong>See Deer Creek in focus.</strong> Preview open kitchens with generous prep space, bright bedrooms with niche-style character, and closets that keep each room feeling polished. Then follow the gallery outside to private patios and balconies, green views, the resident coffee bar, and a resort-style pool framed by a shaded loggia and waterfall.</p>",
  "property_home_neighborhood_blurb": "<p>Deer Creek sits on Metcalf Avenue between 127th and 135th Streets, close to Corbin Park, Town Center Plaza, major Johnson County employers, and healthcare. <a href=\"/neighborhood\">Explore the neighborhood</a> to see what’s nearby.</p>",
  "property_home_reviews_blurb": "<p><strong>What stands out in Deer Creek reviews?</strong> Responsive service, comfortable apartment homes, and a setting that feels well cared for. Residents mention helpful leasing support, maintenance that follows through, spacious layouts with light-filled rooms and roomy kitchens, plus patios framed by trees. Quiet grounds, pools, fitness spaces, clubhouse activities, and garage options round out the everyday details reviewers appreciate. Read the reviews for a closer look at life at Deer Creek Apartment Homes.</p>",
  "property_neighborhood_blurb": "<p>There’s plenty to explore when you call Deer Creek Apartment Homes home. Located on Metcalf Avenue between 127th and 135th Streets in Overland Park, KS, our community puts shopping, dining, outdoor recreation, and everyday conveniences within easy reach.</p><p>Browse the shops at Corbin Park Shopping Center, explore restaurants and retail at Town Center Plaza, or visit Joe’s Kansas City Bar-B-Que. Discover the Overland Park Arboretum and Botanical Gardens, Ironhorse Golf Club, and the Museum at Prairiefire.</p><p>With nearby employers including Garmin International, T-Mobile, and Black &amp; Veatch, along with healthcare facilities and Johnson County Community College, Deer Creek connects you to destinations throughout the Kansas City metro.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that carry their weight.</strong> At Deer Creek Apartment Homes, everyday convenience is built into the experience: concierge service, controlled access, package support, dry cleaning, a car wash station, and on-site management help keep routines moving. When it’s time to reset, you can shift from the business center or coffee station to the clubhouse, grilling areas, walking/biking trails, or a <a href=\"/gallery\">resort-style pool</a> framed by a loggia and waterfall.</p><p>Inside your Overland Park apartment, comfort feels just as considered. In-home laundry, open kitchens, nine-foot ceilings, spacious closets, garden tubs, and private patios or balconies come together with select upgrades like attached garages, granite countertops, kitchen islands, built-in desks, mud rooms, dens, or the signature 16-foot dining-room tower. Compare finishes in the <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Deer Creek home?</strong> Start your application online for Craftsman-inspired apartment living with open kitchens, in-home washers and dryers, spacious closets, and private patios or balconies—plus the everyday ease of a serviced Overland Park community.</p>",
  "property_contactus_blurb": "<p>Have questions? We’re here to help! Whether you’re exploring <a href=\"/floor-plans\">floor plans</a>, checking apartment availability, learning more about our <a href=\"/pet-policy\">pet policy</a>, or getting ready to <a href=\"/schedule-a-tour\">schedule a tour</a>, the Deer Creek Apartment Homes leasing team would love to hear from you.</p><p>Give us a call, send us a message, or stop by our leasing office on Metcalf Avenue in Overland Park, KS. We’re happy to help you explore your options and find a place to call home.</p><p>Already a resident? Visit our <a href=\"/resident-access\">Resident Portal</a> to make a payment or submit a maintenance request.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Deer Creek Apartment Homes?</strong> Start here for quick answers on the community, leasing, apartment features, amenities, and everyday services. If you need more details about making this Overland Park address your next home, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p>Deer Creek Apartment Homes offers nine one-, two-, and three-bedroom floor plans in Overland Park, KS, ranging from 672 to 1,393 square feet.</p><p>Looking for 3 bedroom apartments in Overland Park? Deer Creek’s three-bedroom floor plans are among the largest in the community, with a formal dining room and room for a home office, guest room, or additional storage. Select three-bedroom homes add an attached garage, a mudroom, or a den.</p><p>Every Deer Creek apartment includes nine-foot ceilings, a fully equipped open kitchen, a formal dining room, an in-unit washer and dryer, spacious closets, and a private patio or balcony. Select homes add an attached garage, a kitchen island, granite countertops, coffered ceilings, a built-in desk, a library niche, a mudroom, or a den.</p><p>Compare pricing and availability above, take a <a href=\"/virtual-tours\">virtual tour</a>, or <a href=\"/schedule-a-tour\">schedule a visit</a>.</p>",
  "property_gallery_blurb": "<p>Browse Deer Creek apartment photos, including open kitchens, formal dining rooms, coffered ceilings in select homes, and private patios with atrium doors. Outside, see the resort-style pool with its waterfall and loggia, the clubhouse, the fitness center, and the nature path.</p><p>Take a <a href=\"/virtual-tours\">virtual tour</a> or <a href=\"/schedule-a-tour\">schedule a visit</a> to see Deer Creek in person.</p>",
  "property_interactivemap_blurb": "<p>Finding your next apartment just got easier! Explore Deer Creek Apartment Homes with our interactive leasing map and discover available apartments in Overland Park, KS.</p><p>Browse the community, compare apartment locations, and find <a href=\"/floor-plans\">floor plans</a> and features that fit what you’re looking for. Available filters may include bedrooms, bathrooms, square footage, rent range, move-in date, specials, and amenities.</p><p>Select a home to review available details. Pricing and availability may change, and some listings may direct you to contact the leasing office for current rates. Have questions or want to tour in person? Our <a href=\"/contact-us\">team</a> is here to help.</p><h2>How Interactive Leasing Works</h2><ul><li>Choose your preferred number of bedrooms and bathrooms.</li><li>Filter by rent range, square footage, move-in date, specials, and amenities where available.</li><li>Select a home on the map to review its listed details.</li><li>Contact the leasing team for current pricing, availability, and next steps.</li></ul><h2>Applying Online</h2><p>Contact the leasing office for current application instructions, fees, deposit requirements, and lease terms before applying.</p>",
  "property_pets_blurb": "<p>Your four-legged companions are welcome at Deer Creek Apartment Homes! Our pet-friendly apartments in Overland Park, KS offer spacious layouts, private patios and balconies, and a nature path for enjoying a leashed stroll with your dog.</p><p>We welcome cats and dogs, with up to two pets permitted per apartment home. Have questions about pet fees, breed restrictions, or the <a href=\"https://www.pricebrotherskc.com/petroyaltyclub/\" target=\"_blank\">Price Brothers Pet Royalty Club</a>? Our <a href=\"/contact-us\">leasing team</a> can share more information.</p><h2>Pet Policy at a Glance</h2><ul><li>Dogs and cats are welcome.</li><li>Maximum of two pets per apartment home.</li><li>Monthly pet rent: $25 per pet.</li><li>Nonrefundable pet fee: $300 for one pet or $500 for two pets.</li></ul><h2>Breed Restrictions</h2><p>Breed restrictions apply, including Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and mixes that include these breeds. Management may restrict additional breeds under the published policy. Inherently dangerous, exotic, feral, or wild animals are not permitted. Contact the leasing office for current policy details.</p><h2>Assistance Animals</h2><p>Assistance animals are not considered pets and are not subject to standard pet fees, pet deposits, or breed restrictions. Requests for reasonable accommodations involving assistance animals are reviewed individually in accordance with applicable Fair Housing laws.</p>",
  "property_referafriend_blurb": "<p><strong>Share the Deer Creek experience.</strong> If you love the polished Overland Park address, serviced-community ease, open layouts, and resort-style spaces at Deer Creek Apartment Homes, invite a friend to see it for themselves. Send a referral today and help them find their next home here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access, made easy.</strong> Pay rent, submit maintenance requests, and manage your Deer Creek Apartment Homes account in one convenient place—backed by the everyday ease of on-site management, concierge support, package service, and controlled access.</p>",
  "property_reviews_blurb": "<p><strong>Real feedback, real confidence.</strong> Residents consistently point to the service at Deer Creek Apartment Homes—from helpful leasing support during a quick move to maintenance that responds when it matters. One reviewer summed it up simply: “Management and maintenance take pride in this complex.”</p><p>As you read through the reviews, you’ll see praise for apartment homes that feel spacious and comfortable, with light-filled rooms, roomy kitchens, and patios surrounded by trees. Residents also highlight the quiet setting, well-kept grounds, pools, fitness options, clubhouse activities, garage options, and a layout that “feels like a neighborhood.” If you’re weighing your next move in Deer Creek, these reviews offer a clear look at what day-to-day living here can feel like.</p>",
  "property_created_at": "1785791640382",
  "property_scheduletour_blurb": "<p>Ready to experience Deer Creek Apartment Homes for yourself? Schedule a tour of our apartments in Overland Park, KS, and discover the <a href=\"/floor-plans\">floor plans</a>, <a href=\"/amenities\">amenities</a>, and everyday conveniences that make Deer Creek a place to call home.</p><p>Explore the community with our leasing team, take a closer look at the swimming pool and clubhouse, and ask about floor plans, pricing, and availability. Prefer to explore from home first? Visit our <a href=\"/virtual-tours\">online floor plan tours and videos</a> to get started.</p><p>Find a time that works for you and take the next step toward your new home at Deer Creek!</p><h2>What to Know Before You Visit</h2><p>Contact the leasing office to confirm available tour times, walk-in availability, and any identification requirements before your visit.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong><br>Our leasing team will follow up soon. In the meantime, picture craftsman-inspired comfort in Overland Park, with open layouts, in-home washers and dryers, private patios or balconies, and a serviced community designed to make everyday living feel polished and easy.</p>",
  "property_virtualtours_blurb": "<p>Your next home is just a click away! Explore Deer Creek Apartment Homes through online apartment tours in Overland Park, KS. Take a closer look at available one-, two-, and three-bedroom layouts and get a feel for the space at your own pace.</p><p>Browse available 360° floor plan tours and videos to discover apartment features, from open kitchens and spacious living areas to private patios and balconies. Tour content may vary by floor plan.</p><p>Ready to see more? Check <a href=\"/floor-plans\">current availability</a> or <a href=\"/schedule-a-tour\">schedule a guided tour</a> to experience Deer Creek for yourself.</p>",
  "property_copyright": "2026 All Rights Reserved. Deer Creek Apartment Homes",
  "property_seo_title_home": "Apartments in Overland Park, KS | Deer Creek Apartment Homes",
  "property_seo_description_home": "Explore 1-, 2-, and 3-bedroom apartments in Overland Park, KS at Deer Creek, featuring a resort-style pool, fitness center, and in-home laundry. Schedule a tour.",
  "property_seo_title_floorplans": "1–3 Bedroom Apartments in Overland Park, KS | Deer Creek",
  "property_seo_description_floorplans": "Explore 1, 2, and 3 bedroom apartments in Overland Park, KS at Deer Creek. Compare nine floor plans from 672 to 1,393 sq. ft. and schedule a tour.",
  "property_seo_title_amenities": "Apartment Amenities in Overland Park, KS | Deer Creek",
  "property_seo_description_amenities": "Explore Deer Creek apartment amenities in Overland Park, KS, including a resort-style pool, fitness center, clubhouse, and convenient in-home features.",
  "property_seo_title_gallery": "Overland Park Apartment Photos | Deer Creek",
  "property_seo_description_gallery": "Browse photos of Deer Creek Apartment Homes in Overland Park, KS, including apartment interiors, the resort-style pool, fitness center, and clubhouse.",
  "property_seo_title_virtualtours": "Virtual Apartment Tours in Overland Park, KS | Deer Creek",
  "property_seo_description_virtualtours": "Explore virtual apartment tours in Overland Park, KS at Deer Creek Apartment Homes. Preview floor plans and apartment features online.",
  "property_seo_title_interactivemap": "Apartments for Rent in Overland Park, KS | Deer Creek",
  "property_seo_description_interactivemap": "Explore apartments for rent in Overland Park, KS at Deer Creek. Browse our interactive property map, review available homes, and contact the leasing team.",
  "property_seo_title_neighborhood": "Apartments Near 135th Street in Overland Park, KS",
  "property_seo_description_neighborhood": "Discover Deer Creek apartments near 135th Street and Metcalf Avenue in Overland Park, close to Corbin Park, shopping, dining and local employers.",
  "property_seo_title_contact": "Contact the Leasing Office | Deer Creek Apartment Homes",
  "property_seo_description_contact": "Questions about Deer Creek apartments in Overland Park, KS? Contact our leasing team for floor plans, availability, pet policy details, and tours.",
  "property_seo_title_faqs": "FAQs | Apartments in Overland Park, KS",
  "property_seo_description_faqs": "Find answers to your questions about Deer Creek Apartment Homes in Overland Park, KS. From amenities to floor plans, we’ve got you covered!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Overland Park, KS",
  "property_seo_description_reviews": "Experience the charm of Deer Creek Apartment Homes in Overland Park, KS. Hear directly from our residents about comfort, community & luxury living.",
  "property_seo_title_applynow": "Apply Now | Apartments in Overland Park, KS",
  "property_seo_description_applynow": "Elevate your lifestyle at Deer Creek Apartment Homes! Enjoy resort-style amenities and spacious floor plans. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Deer Creek Apartment Homes",
  "property_seo_description_residentaccess": "Access your Deer Creek resident portal to easily pay rent, schedule maintenance, and stay connected. Your ease in Overland Park is just a click away!",
  "property_seo_title_referafriend": "Refer A Friend | Deer Creek Apartment Homes",
  "property_seo_description_referafriend": "Refer a friend to Deer Creek Apartment Homes in Overland Park, KS! Great friends make for great neighbors—share the joy of living here today!",
  "property_seo_title_scheduletour": "Apartment Tours in Overland Park, KS | Deer Creek",
  "property_seo_description_scheduletour": "Schedule a tour of Deer Creek Apartment Homes in Overland Park, KS. Explore available floor plans, community amenities, and leasing options.",
  "property_seo_title_privacy": "Privacy Policy | Deer Creek Apartment Homes",
  "property_seo_description_privacy": "Safeguarding your info is our priority at Deer Creek Apartment Homes in Overland Park, KS. Read more to understand our commitment to your privacy.",
  "property_seo_title_accessibility": "Website Accessibility | Deer Creek Apartment Homes",
  "property_seo_description_accessibility": "At Deer Creek Apartment Homes in Overland Park, KS, we prioritize accessibility for all. Join us in creating a welcoming, inclusive community for everyone.",
  "property_seo_title_sitemap": "Sitemap | Deer Creek Apartment Homes",
  "property_seo_description_sitemap": "Uncover the charm of Deer Creek Apartment Homes in Overland Park, KS. Navigate our sitemap for effortless access to everything you need to call us home!",
  "property_seo_title_thankyou": "Thank You | Deer Creek Apartment Homes",
  "property_seo_description_thankyou": "Thank you for reaching out! Your journey to comfortable living at Deer Creek Apartment Homes in Overland Park, KS begins here. We’ll be in touch soon!",
  "property_seo_title_pets": "Pet-Friendly Apartments in Overland Park, KS",
  "property_seo_description_pets": "Discover pet-friendly apartments in Overland Park, KS at Deer Creek. Cats and dogs welcome, with up to two pets per home. Explore our pet policy.",
  "property_updated_at": "1793742975377",
  "amenities": [
    {
      "id": "ec_e5a9dde5f710f26fb248457b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87944732",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-8003-76da-a52d-f65bebd7e303.webp",
      "amenity_image_media": {
        "alt_text": "Interior seating area with a bar and tables overlooking a swimming pool and lush greenery.",
        "public_id": "01a01025-8003-76da-a52d-f65bebd7e303",
        "storage_key": "property/6767906449167599/01a01025-8003-76da-a52d-f65bebd7e303.webp",
        "width": 1600,
        "height": 1067
      },
      "amenity_image_alt_text": "Spacious Lounge with pool view at Deer Creek Apartment Homes, Overland Park, KS, 66213",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_00c3e8c2a3d9dbb2b40b7c91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87944730",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-7bc1-72f9-a4f6-095556a1ff94.webp",
      "amenity_image_media": {
        "alt_text": "Built-in wooden desk with computer and shelving unit.",
        "public_id": "01a01025-7bc1-72f9-a4f6-095556a1ff94",
        "storage_key": "property/6767906449167599/01a01025-7bc1-72f9-a4f6-095556a1ff94.webp",
        "width": 1600,
        "height": 1067
      },
      "amenity_image_alt_text": "Work Desk at Deer Creek Apartment Homes, Overland Park, Kansas, 66213",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3db7c68c84571950f207277e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87944734",
      "title": "Concierge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ab733578ab11eb5139cb7466",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87944737",
      "title": "Gated Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a0cc713c5c85fd23bf9042e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87944736",
      "title": "Detached Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1201ec7af8c35c83048ade48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87944731",
      "title": "Car Wash Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8c197af36f7bbb3bada39ad6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87944744",
      "title": "State-Of-The-Art Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a407322a5a4e4a52be350f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87944742",
      "title": "Personal Trainer with Complimentary Fitness Classes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0b528fcf09e6f90ba27387f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87944733",
      "title": "Coffee Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-82ac-77cd-b36b-7083a8d885c2.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with wooden cabinets, stone floor, and coffee station.",
        "public_id": "01a01025-82ac-77cd-b36b-7083a8d885c2",
        "storage_key": "property/6767906449167599/01a01025-82ac-77cd-b36b-7083a8d885c2.webp",
        "width": 1600,
        "height": 1067
      },
      "amenity_image_alt_text": "Well Equipped and Decorated Kitchen at Deer Creek Apartment Homes, Overland Park",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b13a867bd0bb954e467f01ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87944740",
      "title": "Monthly Resident Events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ed50831f1a576f700243cb17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87944743",
      "title": "Resort Style Pool with Loggia and Waterfall",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-7a07-75f3-834e-88de90caefe5.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a clubhouse with large windows.",
        "public_id": "01a01025-7a07-75f3-834e-88de90caefe5",
        "storage_key": "property/6767906449167599/01a01025-7a07-75f3-834e-88de90caefe5.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Classic Swimming Pool View at Deer Creek Apartment Homes, Kansas, 66213,Outdoor patios with tables, chairs and fireplace at Deer Creek Apartment Homes, Kansas,Pool Side Relaxing Area With Lounge Area at Deer Creek Apartment Homes, Overland Park, Kansas,Large Crystal Clear Shimmering Pool at Deer Creek Apartment Homes, Overland Park, 66213,Pool in the backyard at Deer Creek Apartment Homes, Overland Park,Fireplace in the outdoor covered patios at Deer Creek Apartment Homes, Overland Park, KS,Resort Inspired Crystal Clear Swimming Pool at Deer Creek Apartment Homes, Overland Park, KS, 66213,Covered Patio with fireplace at Deer Creek Apartment Homes, Kansas, 66213,Front Pool View at Deer Creek Apartment Homes, Kansas,Crystal Clear Swimming Pool at Deer Creek Apartment Homes, Overland Park, Kansas,Pristine swimming pool at Deer Creek Apartment Homes, Overland Park, 66213",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1c933be5ebc1c721111007ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87944735",
      "title": "Copy & Fax Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_697f1805b5823cf5e49fc0ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "122755371",
      "title": "Flexible Rent Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7313fc96cb51c152bac98c8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87967570",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-7909-760c-ab42-b0b60e4f1ca6.webp",
      "amenity_image_media": {
        "alt_text": "Living room and kitchen area with a sofa, armchair, bar stools, and dining table.",
        "public_id": "01a01025-7909-760c-ab42-b0b60e4f1ca6",
        "storage_key": "property/6767906449167599/01a01025-7909-760c-ab42-b0b60e4f1ca6.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Spacious Decorated Living room with Ceiling Fan at Deer Creek Apartment Homes, Overland Park, KS,Bedroom with a Large Comfortable bed at Deer Creek Apartment Homes, Overland Park, KS, 66213",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5a48a8238778273f8cf58c4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87944749",
      "title": "Attached Garage Included*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3b66019cca998703c1dc3376",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87944767",
      "title": "In-Unit Washer & Dryer Included",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6f276dd184037e151c29e7ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87944746",
      "title": "9-Foot Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-84e8-742e-9dd1-c856244270ea.webp",
      "amenity_image_media": {
        "alt_text": "Living room with sofa, armchair, coffee table, and a kitchen bar with stools.",
        "public_id": "01a01025-84e8-742e-9dd1-c856244270ea",
        "storage_key": "property/6767906449167599/01a01025-84e8-742e-9dd1-c856244270ea.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Modern Living room and Kitchen view at Deer Creek Apartment Homes, Kansas,Lavish Living room with Oversized windows with blinds at Deer Creek Apartment Homes, Overland Park, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bb38c181b6a4ed1f39ea4477",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87944753",
      "title": "Coffered Ceiling*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cf806a0fdb74f61da8bbd9ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87944764",
      "title": "Fully-Equipped, Open Kitchen Design",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-8740-75ec-83bb-ed83732303ee.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with stainless steel appliances, wood cabinets, and granite countertops.",
        "public_id": "01a01025-8740-75ec-83bb-ed83732303ee",
        "storage_key": "property/6767906449167599/01a01025-8740-75ec-83bb-ed83732303ee.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Kitchen with stainless steel appliances and wooden cabinets at Deer Creek Apartment Homes, Overland Park",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f560f851d1b74e89963efe83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87944757",
      "title": "Kitchen Island*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-8b32-7067-891f-b1e41f4216b8.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with wood cabinets, white appliances, and a large island.",
        "public_id": "01a01025-8b32-7067-891f-b1e41f4216b8",
        "storage_key": "property/6767906449167599/01a01025-8b32-7067-891f-b1e41f4216b8.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Modern Kitchen with small island at Deer Creek Apartment Homes, Overland Park, 66213",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_79f612988b4a5e751493416c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87944763",
      "title": "Natural Oak Cabinets*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-8740-75ec-83bb-ed83732303ee.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with stainless steel appliances, wood cabinets, and granite countertops.",
        "public_id": "01a01025-8740-75ec-83bb-ed83732303ee",
        "storage_key": "property/6767906449167599/01a01025-8740-75ec-83bb-ed83732303ee.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Luxurious Kitchen Interior at Deer Creek Apartment Homes, Kansas,Luxurious Bathroom Interior at Deer Creek Apartment Homes, Overland Park, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f1a8ee1f79b8cfe31a81ff9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "122010477",
      "title": "Espresso Cabinets*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7290b6d1b365c8c8a3d02ab3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "122010482",
      "title": "Granite Countertops*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f7ed0336ec672b34fe530318",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87944760",
      "title": "Main Suite*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-903a-7506-bef2-603ec23e8f1b.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstands, and a view into the en-suite bathroom.",
        "public_id": "01a01025-903a-7506-bef2-603ec23e8f1b",
        "storage_key": "property/6767906449167599/01a01025-903a-7506-bef2-603ec23e8f1b.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Bedroom with cozy bed and nightstand at Deer Creek Apartment Homes, Overland Park, KS,Cozy bedroom with bed and comforter at Deer Creek Apartment Homes, Overland Park, KS, 66213",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7d3519f524cd91f06121dd9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87944759",
      "title": "Library Niche*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-92e2-716f-8a06-fb49c4675972.webp",
      "amenity_image_media": {
        "alt_text": "Primary bedroom with a king-size bed, bedside tables, and artwork on the walls.",
        "public_id": "01a01025-92e2-716f-8a06-fb49c4675972",
        "storage_key": "property/6767906449167599/01a01025-92e2-716f-8a06-fb49c4675972.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Bedroom with Natural Light and Oversized windows at Deer Creek Apartment Homes, Overland Park,Luxurious bedroom with TV at Deer Creek Apartment Homes, Kansas, 66213",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4cec5507ef9a8d21de308027",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87944756",
      "title": "Formal Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-94bb-70ac-8ef0-2ce405d6ea75.webp",
      "amenity_image_media": {
        "alt_text": "Dining area with a round table and chairs next to a living room.",
        "public_id": "01a01025-94bb-70ac-8ef0-2ce405d6ea75",
        "storage_key": "property/6767906449167599/01a01025-94bb-70ac-8ef0-2ce405d6ea75.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Dining room with Living room view at Deer Creek Apartment Homes, Overland Park, KS,Dining room with wooden table and chairs with bedroom view at Deer Creek Apartment Homes, Overland Park, KS, 66213",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8368d18fd5b8dc6e8e4759fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87944745",
      "title": "16-Foot Tower in Dining Room*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2f7590d1d4da09c69fc02684",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87944765",
      "title": "Private Balconies and Patios",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-9501-70c0-8bd5-77653a8a2000.webp",
      "amenity_image_media": {
        "alt_text": "Covered balcony with seating area and double doors.",
        "public_id": "01a01025-9501-70c0-8bd5-77653a8a2000",
        "storage_key": "property/6767906449167599/01a01025-9501-70c0-8bd5-77653a8a2000.webp",
        "width": 1200,
        "height": 799
      },
      "amenity_image_alt_text": "Lavish Private Patios with comfortable chairs at Deer Creek Apartment Homes, Overland Park, 66213,Large Balcony with black railing at Deer Creek Apartment Homes, Overland Park",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b58e91c8d302f3afa21a8435",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87944748",
      "title": "Atrium Doors to Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-9501-70c0-8bd5-77653a8a2000.webp",
      "amenity_image_media": {
        "alt_text": "Covered balcony with seating area and double doors.",
        "public_id": "01a01025-9501-70c0-8bd5-77653a8a2000",
        "storage_key": "property/6767906449167599/01a01025-9501-70c0-8bd5-77653a8a2000.webp",
        "width": 1200,
        "height": 799
      },
      "amenity_image_alt_text": "Comfortable Chairs in the Large Patio at Deer Creek Apartment Homes, Kansas,Luxurious Apartment Interiors at Deer Creek Apartment Homes, Overland Park, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d8865eb3f0e84c5d24f208d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87944762",
      "title": "Mud Room*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-9997-7528-98a1-00b4064918b3.webp",
      "amenity_image_media": {
        "alt_text": "Built-in bench with storage and shelves, adjacent to a kitchen counter with bar stools.",
        "public_id": "01a01025-9997-7528-98a1-00b4064918b3",
        "storage_key": "property/6767906449167599/01a01025-9997-7528-98a1-00b4064918b3.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Shelves with decor at Deer Creek Apartment Homes, Kansas, 66213",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4eceb740b374bbade733ee64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87944754",
      "title": "Den/Study*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8a654d7cd8725df2c1a771b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87944750",
      "title": "Built-in Computer Desk*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_195f6c449c853d282e8a78e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87944758",
      "title": "Large Garden Tub",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1daf6a0013b8490f31e91282",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "87944766",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-9e6c-7730-8538-b56c825c9b5d.webp",
      "amenity_image_media": {
        "alt_text": "Walk-in closet with organized clothing on shelves and hanging rods.",
        "public_id": "01a01025-9e6c-7730-8538-b56c825c9b5d",
        "storage_key": "property/6767906449167599/01a01025-9e6c-7730-8538-b56c825c9b5d.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Large walk-in closets with shelves and clothes hanging at Deer Creek Apartment Homes, Overland Park, 66213",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8e2db4d8a4ff48ddf618ab0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "external_id": "122010470",
      "title": "Upgraded Lighting*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_d9471165761358e731326acc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-6bdc-71af-9c86-230427b1f7f6.webp",
      "image_media": {
        "alt_text": "Dining room and living room with kitchen in background.",
        "public_id": "01a01025-6bdc-71af-9c86-230427b1f7f6",
        "storage_key": "property/6767906449167599/01a01025-6bdc-71af-9c86-230427b1f7f6.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Elegant dining area with a dark wood table set for six, adjacent to a spacious living room and a modern kitchen.",
      "link": "false",
      "alt_text": "Dining room and living room with kitchen in background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/25-12849 Metcalf Ave Virt Staging-3.jpg"
    },
    {
      "id": "ec_96b7d8d5f3349b580fd3a9d8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-ab9c-745c-896f-c905aa9635ae.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-sized bed, a large TV, and a sitting area with two chairs and a small table.",
        "public_id": "01a01025-ab9c-745c-896f-c905aa9635ae",
        "storage_key": "property/6767906449167599/01a01025-ab9c-745c-896f-c905aa9635ae.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-sized bed, a wall-mounted TV, and a cozy seating area by the window, perfect for relaxation.",
      "link": "false",
      "alt_text": "Bedroom with a king-sized bed, a large TV, and a sitting area with two chairs and a small table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/28-12849 Metcalf Ave Virt Staging-6.jpg"
    },
    {
      "id": "ec_e29960eaa56b97e80bfae737",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-a9a7-7778-a48d-a1a4c993ba15.webp",
      "image_media": {
        "alt_text": "Living room with sofa, coffee table, and armchair, open to a kitchen counter with bar stools.",
        "public_id": "01a01025-a9a7-7778-a48d-a1a4c993ba15",
        "storage_key": "property/6767906449167599/01a01025-a9a7-7778-a48d-a1a4c993ba15.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living area flows seamlessly into the kitchen, perfect for entertaining. Enjoy comfortable seating and a convenient breakfast bar.",
      "link": "false",
      "alt_text": "Living room with sofa, coffee table, and armchair, open to a kitchen counter with bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-12849 Metcalf -1.jpg"
    },
    {
      "id": "ec_7d110c4f244cb2e90ea440ca",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-a930-718c-857c-48ffc74e0f51.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel refrigerator, oven, and microwave.",
        "public_id": "01a01025-a930-718c-857c-48ffc74e0f51",
        "storage_key": "property/6767906449167599/01a01025-a930-718c-857c-48ffc74e0f51.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A modern kitchen featuring light wood cabinets, granite countertops, and stainless steel appliances. Includes a double sink and ample cabinet space.",
      "link": "false",
      "alt_text": "Kitchen with stainless steel refrigerator, oven, and microwave.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/06-12849 Metcalf -6.jpg"
    },
    {
      "id": "ec_1f28501f1c8912d01ffb7516",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-a946-7102-b555-35e7611093af.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment with a couch, chair, and bar stools.",
        "public_id": "01a01025-a946-7102-b555-35e7611093af",
        "storage_key": "property/6767906449167599/01a01025-a946-7102-b555-35e7611093af.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living room seamlessly transitions into a modern kitchen area, perfect for entertaining.",
      "link": "false",
      "alt_text": "Living room and kitchen area of an apartment with a couch, chair, and bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/03-12849 Metcalf -3.jpg"
    },
    {
      "id": "ec_0d7d08e2183dcbaf8af68192",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-a93c-7266-8837-b1e87e596bd5.webp",
      "image_media": {
        "alt_text": "Dining area with round table and chairs, adjacent to a living room with sofa and armchair.",
        "public_id": "01a01025-a93c-7266-8837-b1e87e596bd5",
        "storage_key": "property/6767906449167599/01a01025-a93c-7266-8837-b1e87e596bd5.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Chic dining area featuring a round table with stylish chairs, perfect for meals. The adjacent living room offers comfortable seating and modern decor.",
      "link": "false",
      "alt_text": "Dining area with round table and chairs, adjacent to a living room with sofa and armchair.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/05-12849 Metcalf -5.jpg"
    },
    {
      "id": "ec_5ea2d312768c4a8399801944",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-b819-751d-959f-23b8c4234cd7.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, white appliances, and a granite island.",
        "public_id": "01a01025-b819-751d-959f-23b8c4234cd7",
        "storage_key": "property/6767906449167599/01a01025-b819-751d-959f-23b8c4234cd7.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring ample wooden cabinetry, a full suite of white appliances including a refrigerator, stove, microwave, and dishwasher, complemented by a sleek granite island.",
      "link": "false",
      "alt_text": "Kitchen with wooden cabinets, white appliances, and a granite island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/15-12849 Metcalf Ave -15.jpg"
    },
    {
      "id": "ec_c099635fc149d1550f1f7eab",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-b952-7488-8ff6-7da01c3a3687.webp",
      "image_media": {
        "alt_text": "Dining area with table and chairs, view into bedroom.",
        "public_id": "01a01025-b952-7488-8ff6-7da01c3a3687",
        "storage_key": "property/6767906449167599/01a01025-b952-7488-8ff6-7da01c3a3687.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy elegant dining in this spacious apartment, featuring a bright dining area and a comfortable bedroom.",
      "link": "false",
      "alt_text": "Dining area with table and chairs, view into bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/04-12849 Metcalf -4.jpg"
    },
    {
      "id": "ec_a673ada4f5b66aebebb39dc7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-c114-716a-93d6-c718e5a60b3b.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and shower.",
        "public_id": "01a01025-c114-716a-93d6-c718e5a60b3b",
        "storage_key": "property/6767906449167599/01a01025-c114-716a-93d6-c718e5a60b3b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a dual vanity with ample counter space, a toilet, and a shower with a glass enclosure. This bathroom provides a clean and functional space.",
      "link": "false",
      "alt_text": "Bathroom with vanity, toilet, and shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/09-12849 Metcalf -9(1).jpg"
    },
    {
      "id": "ec_6b9e8e9ddf21b5d6239fbf47",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-b9a1-778b-975e-4d88558cae69.webp",
      "image_media": {
        "alt_text": "Walk-in closet with white wire shelving and organized clothing.",
        "public_id": "01a01025-b9a1-778b-975e-4d88558cae69",
        "storage_key": "property/6767906449167599/01a01025-b9a1-778b-975e-4d88558cae69.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample white wire shelving for organized storage of folded and hung clothing.",
      "link": "false",
      "alt_text": "Walk-in closet with white wire shelving and organized clothing.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/26-12849 Metcalf Ave Virt Staging-4.jpg"
    },
    {
      "id": "ec_582a7b5237d60e2ce1dda853",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-c2b8-713f-a09e-63ece7017a07.webp",
      "image_media": {
        "alt_text": "Bar and seating area in community clubhouse with stone pillars and large windows overlooking greenery.",
        "public_id": "01a01025-c2b8-713f-a09e-63ece7017a07",
        "storage_key": "property/6767906449167599/01a01025-c2b8-713f-a09e-63ece7017a07.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Enjoy a drink at the bar in our community clubhouse. Features comfortable seating, stone accents, and beautiful views of the surrounding landscape.",
      "link": "false",
      "alt_text": "Bar and seating area in community clubhouse with stone pillars and large windows overlooking greenery.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/3DC-Amenities-14.jpg"
    },
    {
      "id": "ec_f8be1d5cadb0089b19d275c5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-8003-76da-a52d-f65bebd7e303.webp",
      "image_media": {
        "alt_text": "Interior seating area with a bar and tables overlooking a swimming pool and lush greenery.",
        "public_id": "01a01025-8003-76da-a52d-f65bebd7e303",
        "storage_key": "property/6767906449167599/01a01025-8003-76da-a52d-f65bebd7e303.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Enjoy a relaxing moment in our indoor seating area, complete with a full-service bar and comfortable tables, offering stunning views of the sparkling swimming pool and vibrant landscape.",
      "link": "false",
      "alt_text": "Interior seating area with a bar and tables overlooking a swimming pool and lush greenery.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/3DC-Amenities-16.jpg"
    },
    {
      "id": "ec_363a2d3dfccb0710fe88bd9c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-82ac-77cd-b36b-7083a8d885c2.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, stone floor, and coffee station.",
        "public_id": "01a01025-82ac-77cd-b36b-7083a8d885c2",
        "storage_key": "property/6767906449167599/01a01025-82ac-77cd-b36b-7083a8d885c2.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Beautifully appointed kitchen featuring custom wooden cabinetry, a stone tile backsplash, a convenient coffee station, and a unique stone floor.",
      "link": "false",
      "alt_text": "Kitchen with wooden cabinets, stone floor, and coffee station.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/3DC-Amenities-19.jpg"
    },
    {
      "id": "ec_6bdfae251c5d72520d35a812",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-7bc1-72f9-a4f6-095556a1ff94.webp",
      "image_media": {
        "alt_text": "Built-in wooden desk with computer and shelving unit.",
        "public_id": "01a01025-7bc1-72f9-a4f6-095556a1ff94",
        "storage_key": "property/6767906449167599/01a01025-7bc1-72f9-a4f6-095556a1ff94.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "A sleek built-in wooden desk with a computer and an integrated shelving unit, perfect for a home office or study nook within an apartment.",
      "link": "false",
      "alt_text": "Built-in wooden desk with computer and shelving unit.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/3DC-Amenities-23.jpg"
    },
    {
      "id": "ec_1e61fea2fc3b2f5ad9d24e3c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-ce05-7498-a3ec-4d21a865ed74.webp",
      "image_media": {
        "alt_text": "Lobby seating area with stone pillars, comfortable armchairs, and abstract art.",
        "public_id": "01a01025-ce05-7498-a3ec-4d21a865ed74",
        "storage_key": "property/6767906449167599/01a01025-ce05-7498-a3ec-4d21a865ed74.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Relax and unwind in the inviting lobby seating area, featuring comfortable armchairs, natural stone accents, and a beautiful piece of abstract art.",
      "link": "false",
      "alt_text": "Lobby seating area with stone pillars, comfortable armchairs, and abstract art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/3DC-Amenities-25.jpg"
    },
    {
      "id": "ec_aab67e1d513e18e5c2133766",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-c94b-72a6-a219-15cbb7a42dea.webp",
      "image_media": {
        "alt_text": "Community library with extensive bookshelves and reading nooks",
        "public_id": "01a01025-c94b-72a6-a219-15cbb7a42dea",
        "storage_key": "property/6767906449167599/01a01025-c94b-72a6-a219-15cbb7a42dea.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Enjoy a quiet moment in our community library, complete with a vast collection of books and comfortable seating areas.",
      "link": "false",
      "alt_text": "Community library with extensive bookshelves and reading nooks",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/3DC-Amenities-26.jpg"
    },
    {
      "id": "ec_18126cadc00e3e481f8473c0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-c8f3-704e-b306-ae00697f335b.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with stone facade and garages.",
        "public_id": "01a01025-c8f3-704e-b306-ae00697f335b",
        "storage_key": "property/6767906449167599/01a01025-c8f3-704e-b306-ae00697f335b.webp",
        "width": 1342,
        "height": 895
      },
      "title": "Community",
      "description": "This exterior shot showcases the beautiful stone facade and attached garages of the apartment complex.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with stone facade and garages.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/3DC-Amenities-27.jpg"
    },
    {
      "id": "ec_6598ec7e6d8bfb5c53893094",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-da26-7079-b48a-329f68c508eb.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with attached garages, balcony, and picnic area.",
        "public_id": "01a01025-da26-7079-b48a-329f68c508eb",
        "storage_key": "property/6767906449167599/01a01025-da26-7079-b48a-329f68c508eb.webp",
        "width": 1535,
        "height": 1023
      },
      "title": "Community",
      "description": "Exterior view showcasing the architecture of the apartment building, featuring attached garages, a private balcony, and an inviting picnic area with a grill for residents to enjoy.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with attached garages, balcony, and picnic area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/3DC-Amenities-38.jpg"
    },
    {
      "id": "ec_f63d979c280b2d68c2c7ed33",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-e18d-74f9-88c2-2a181ba49a74.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with attached garages and a balcony overlooking the drive.",
        "public_id": "01a01025-e18d-74f9-88c2-2a181ba49a74",
        "storage_key": "property/6767906449167599/01a01025-e18d-74f9-88c2-2a181ba49a74.webp",
        "width": 1430,
        "height": 954
      },
      "title": "Community",
      "description": "Spacious apartment building exterior featuring attached garages, a stone facade, and a balcony with seating.",
      "link": "false",
      "alt_text": "Apartment building exterior with attached garages and a balcony overlooking the drive.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/3DC-Amenities-28.jpg"
    },
    {
      "id": "ec_d251108883cfa1d4e9f5f401",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-df38-729c-b949-214abfb7e187.webp",
      "image_media": {
        "alt_text": "Modern living area and kitchen with island and dining space",
        "public_id": "01a01025-df38-729c-b949-214abfb7e187",
        "storage_key": "property/6767906449167599/01a01025-df38-729c-b949-214abfb7e187.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living area flows seamlessly into a modern kitchen with island seating. Perfect for entertaining and comfortable living.",
      "link": "false",
      "alt_text": "Modern living area and kitchen with island and dining space",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/23-12849 Metcalf Ave Virt Staging-1.jpg"
    },
    {
      "id": "ec_71e2c6567052f1e797e5b418",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-e2a6-75ad-9afe-00063f3d284f.webp",
      "image_media": {
        "alt_text": "A dining room with a dark wood table set for six, adjacent to a living room with a white sofa.",
        "public_id": "01a01025-e2a6-75ad-9afe-00063f3d284f",
        "storage_key": "property/6767906449167599/01a01025-e2a6-75ad-9afe-00063f3d284f.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Apartment",
      "description": "Enjoy elegant dining in this beautifully appointed dining room, perfect for hosting guests. Adjacent to a comfortable living space.",
      "link": "false",
      "alt_text": "A dining room with a dark wood table set for six, adjacent to a living room with a white sofa.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/24-12849 Metcalf Ave Virt Staging-2.jpg"
    },
    {
      "id": "ec_544e22660a805377cf7884ce",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-e7d3-7479-baa0-b6aac5ea99f7.webp",
      "image_media": {
        "alt_text": "Balcony view with trees and a street",
        "public_id": "01a01025-e7d3-7479-baa0-b6aac5ea99f7",
        "storage_key": "property/6767906449167599/01a01025-e7d3-7479-baa0-b6aac5ea99f7.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "Enjoy the outdoors from your private balcony, offering scenic views of the surrounding trees and neighborhood street.",
      "link": "false",
      "alt_text": "Balcony view with trees and a street",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/21-12849 Metcalf Ave -21.jpg"
    },
    {
      "id": "ec_e5cea0822eecd12ac0bb5f78",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-ec6c-74d7-994f-c71e8bbd8394.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with a king-size bed, modern decor, and natural light.",
        "public_id": "01a01025-ec6c-74d7-994f-c71e8bbd8394",
        "storage_key": "property/6767906449167599/01a01025-ec6c-74d7-994f-c71e8bbd8394.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed bedroom, featuring a comfortable king-size bed, elegant decor, and abundant natural light. Perfect for a restful retreat.",
      "link": "false",
      "alt_text": "Spacious bedroom with a king-size bed, modern decor, and natural light.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/29-12849 Metcalf Ave Virt Staging-7.jpg"
    },
    {
      "id": "ec_bee327f9fb67ec67c0074456",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-f00d-7348-9989-33b19721a168.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, a TV stand, and a ceiling fan.",
        "public_id": "01a01025-f00d-7348-9989-33b19721a168",
        "storage_key": "property/6767906449167599/01a01025-f00d-7348-9989-33b19721a168.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-size bed, a modern TV stand with a mounted television, and a ceiling fan for comfort.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, a TV stand, and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/27-12849 Metcalf Ave Virt Staging-5.jpg"
    },
    {
      "id": "ec_9e5010f8841cf68567c8dce2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-f128-7239-96b2-a04cedcdc30b.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, armchair, coffee table, and artwork on the wall.",
        "public_id": "01a01025-f128-7239-96b2-a04cedcdc30b",
        "storage_key": "property/6767906449167599/01a01025-f128-7239-96b2-a04cedcdc30b.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable sofa, a chic armchair, a modern coffee table, and decorative wall art, perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Living room with a sofa, armchair, coffee table, and artwork on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/02-12849 Metcalf -2.jpg"
    },
    {
      "id": "ec_43f7f3634dea8118bcc36a47",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01026-019c-749c-9447-c59fdde6315b.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, toilet, and glass-enclosed shower.",
        "public_id": "01a01026-019c-749c-9447-c59fdde6315b",
        "storage_key": "property/6767906449167599/01a01026-019c-749c-9447-c59fdde6315b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a spacious vanity with a single sink, a clean white toilet, and a sleek glass-enclosed shower with white tiled walls.",
      "link": "false",
      "alt_text": "Bathroom with vanity, sink, toilet, and glass-enclosed shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/13-12849 Metcalf -13(1).jpg"
    },
    {
      "id": "ec_3aa2a1fb9e833096a0e92f15",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-f86d-713a-b997-53ab14f2b1f5.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building with large windows.",
        "public_id": "01a01025-f86d-713a-b997-53ab14f2b1f5",
        "storage_key": "property/6767906449167599/01a01025-f86d-713a-b997-53ab14f2b1f5.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and scenic views of the community clubhouse.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and a building with large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/03-12849 Metcalf Ave -3.jpg"
    },
    {
      "id": "ec_b5b11091131d21f14f5fefe8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-fac6-771b-ad84-0a41441a7715.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building with large windows.",
        "public_id": "01a01025-fac6-771b-ad84-0a41441a7715",
        "storage_key": "property/6767906449167599/01a01025-fac6-771b-ad84-0a41441a7715.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and a stylish clubhouse.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and a building with large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-12849 Metcalf Ave -1.jpg"
    },
    {
      "id": "ec_38e7607370e50cdd0269216d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01025-fc86-713e-992c-b7a26ac92a3b.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a waterfall feature.",
        "public_id": "01a01025-fc86-713e-992c-b7a26ac92a3b",
        "storage_key": "property/6767906449167599/01a01025-fc86-713e-992c-b7a26ac92a3b.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, complete with a cascading waterfall and ample lounge seating for ultimate relaxation.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and a waterfall feature.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/05-12849 Metcalf Ave -5.jpg"
    },
    {
      "id": "ec_554c9253fae3221f6f19c980",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01026-0537-7325-8d7b-43300bbea2d4.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with a waterfall feature in front of a building with large glass windows.",
        "public_id": "01a01026-0537-7325-8d7b-43300bbea2d4",
        "storage_key": "property/6767906449167599/01a01026-0537-7325-8d7b-43300bbea2d4.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning outdoor swimming pool, complete with a cascading waterfall feature. Relax in style by the water's edge.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with a waterfall feature in front of a building with large glass windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/06-12849 Metcalf Ave -6.jpg"
    },
    {
      "id": "ec_63385351b3f8d4a46bd444ab",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01026-0823-71d7-a307-b0716fa39b0e.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with a stone waterfall feature and lounge chairs.",
        "public_id": "01a01026-0823-71d7-a307-b0716fa39b0e",
        "storage_key": "property/6767906449167599/01a01026-0823-71d7-a307-b0716fa39b0e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax by the stunning outdoor swimming pool, complete with a soothing stone waterfall and comfortable lounge seating.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with a stone waterfall feature and lounge chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/04-12849 Metcalf Ave -4.jpg"
    },
    {
      "id": "ec_df0ff9165004b707b3c3cf07",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01026-0bab-71da-8eec-d133ac49dcee.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge seating and umbrellas.",
        "public_id": "01a01026-0bab-71da-8eec-d133ac49dcee",
        "storage_key": "property/6767906449167599/01a01026-0bab-71da-8eec-d133ac49dcee.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling outdoor swimming pool, complete with comfortable lounge seating and shaded umbrellas.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge seating and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/02-12849 Metcalf Ave -2.jpg"
    },
    {
      "id": "ec_ed1170931c893102df76cd48",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01026-1447-702a-98b3-61e490d72762.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with a waterfall feature and lounge chairs.",
        "public_id": "01a01026-1447-702a-98b3-61e490d72762",
        "storage_key": "property/6767906449167599/01a01026-1447-702a-98b3-61e490d72762.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with a beautiful waterfall and comfortable lounge chairs for ultimate relaxation.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with a waterfall feature and lounge chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/07-12849 Metcalf Ave -7.jpg"
    },
    {
      "id": "ec_68df916f08aafe863b9bc1d5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01026-18c2-738a-b8b1-df03aae6159f.webp",
      "image_media": {
        "alt_text": "Covered patio with stone fireplace and outdoor seating.",
        "public_id": "01a01026-18c2-738a-b8b1-df03aae6159f",
        "storage_key": "property/6767906449167599/01a01026-18c2-738a-b8b1-df03aae6159f.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy outdoor living on this spacious, covered patio featuring a cozy stone fireplace and comfortable seating area, perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Covered patio with stone fireplace and outdoor seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/11-12849 Metcalf Ave -11.jpg"
    },
    {
      "id": "ec_cc8a3c349f99f356c3663e6e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01026-1aea-774c-90d7-fff7dfde00d9.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and seating.",
        "public_id": "01a01026-1aea-774c-90d7-fff7dfde00d9",
        "storage_key": "property/6767906449167599/01a01026-1aea-774c-90d7-fff7dfde00d9.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and convenient seating areas for you to unwind.",
      "link": "false",
      "alt_text": "Outdoor swimming pool area with lounge chairs and seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/08-12849 Metcalf Ave -8.jpg"
    },
    {
      "id": "ec_412550525959cbbd1aa84637",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01026-1cf0-72de-8340-cc1bc1058b7f.webp",
      "image_media": {
        "alt_text": "Covered patio with seating area and outdoor dining set.",
        "public_id": "01a01026-1cf0-72de-8340-cc1bc1058b7f",
        "storage_key": "property/6767906449167599/01a01026-1cf0-72de-8340-cc1bc1058b7f.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy outdoor living on this beautifully appointed covered patio, perfect for relaxation and dining.",
      "link": "false",
      "alt_text": "Covered patio with seating area and outdoor dining set.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/10-12849 Metcalf Ave -10.jpg"
    },
    {
      "id": "ec_f1051c419851d11622462081",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01026-2541-7199-92e7-8bde50cda3af.webp",
      "image_media": {
        "alt_text": "Covered outdoor patio with seating and dining areas",
        "public_id": "01a01026-2541-7199-92e7-8bde50cda3af",
        "storage_key": "property/6767906449167599/01a01026-2541-7199-92e7-8bde50cda3af.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy outdoor living on this spacious covered patio, complete with comfortable seating and a dining area.",
      "link": "false",
      "alt_text": "Covered outdoor patio with seating and dining areas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/09-12849 Metcalf Ave -9.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_1d252801-71cf-474a-84d4-b7857b48b247",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Pilgrim Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "12643 Metcalf Ave, Overland Park, KS 66213, USA",
      "poi_short_description": "Friendly, clean, modern cafe offering gourmet coffee and a selection of pastries and other bites.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97d-9bef-758d-bb14-cce99c8b84e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-9bef-758d-bb14-cce99c8b84e2",
        "storage_key": "property/6767906449167599/019fc97d-9bef-758d-bb14-cce99c8b84e2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.pilgrimcoffeecompany.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=238072773954974834&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pilgrim-coffee-company",
      "poi_latitude": "38.8994057",
      "poi_longitude": "-94.666405",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-258-5415",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97f-a35d-754e-acf7-b44c0c32cbf6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97f-a35d-754e-acf7-b44c0c32cbf6",
        "storage_key": "property/6767906449167599/019fc97f-a35d-754e-acf7-b44c0c32cbf6.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJIWWZr3TqwIcRcjRHMu3NTQM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_e968a555-1f0c-43d5-81ce-baeea83f3d24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Minsky's Pizza - Metcalf",
      "poi_type": "Restaurants",
      "poi_address": "12627 Metcalf Ave, Overland Park, KS 66213, USA",
      "poi_short_description": "Elevated pizzeria chain with lots of crust & topping options, plus spaghetti & cheesesteaks.",
      "poi_long_description": "Elevated pizzeria chain with lots of crust & topping options, plus spaghetti & cheesesteaks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97d-8404-72f9-9cdb-3071b1e7e6e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-8404-72f9-9cdb-3071b1e7e6e9",
        "storage_key": "property/6767906449167599/019fc97d-8404-72f9-9cdb-3071b1e7e6e9.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://minskys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12581644930266502098&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "minskys-pizza---metcalf",
      "poi_latitude": "38.8998847",
      "poi_longitude": "-94.6662016",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-839-0021",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8fe0-732f-924c-939023690013.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8fe0-732f-924c-939023690013",
        "storage_key": "property/6767906449167599/019fc97a-8fe0-732f-924c-939023690013.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ180VnPqwIcR0hOhVmf7mq4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_e7aa269f-93c3-4237-ba64-2b99ddc3bf67",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Kurry Leaves Indian Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "12607 Metcalf Ave, Overland Park, KS 66213, USA",
      "poi_short_description": "Classic dishes of India & Pakistan are prepared with halal meats & served in a simple storefront.",
      "poi_long_description": "Classic dishes of India & Pakistan are prepared with halal meats & served in a simple storefront.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97d-8a63-76e8-b1cb-7200cc5a283b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-8a63-76e8-b1cb-7200cc5a283b",
        "storage_key": "property/6767906449167599/019fc97d-8a63-76e8-b1cb-7200cc5a283b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://kckurryleaves.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=10984871875640188476&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kurry-leaves-indian-cuisine",
      "poi_latitude": "38.9002809",
      "poi_longitude": "-94.6664154",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-296-8482",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8fe0-732f-924c-939023690013.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8fe0-732f-924c-939023690013",
        "storage_key": "property/6767906449167599/019fc97a-8fe0-732f-924c-939023690013.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCcIte3PqwIcRPF62QsUacpg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "custom_675c52b7-4e1b-49c9-88e7-31e2e89369a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "The Peanut",
      "poi_type": "Restaurants",
      "poi_address": "12663 Metcalf Ave, Overland Park, KS 66209, USA",
      "poi_short_description": "Sports bar & grill with classic American pub grub such as BLTs & spicy wings as well as drinks.",
      "poi_long_description": "Sports bar & grill with classic American pub grub such as BLTs & spicy wings as well as drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97d-92fb-708c-a2cc-efe5247d0d53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-92fb-708c-a2cc-efe5247d0d53",
        "storage_key": "property/6767906449167599/019fc97d-92fb-708c-a2cc-efe5247d0d53.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://peanutmidwest.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2276153363687956292&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-peanut",
      "poi_latitude": "38.8990944",
      "poi_longitude": "-94.6662929",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-491-0288",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8fe0-732f-924c-939023690013.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8fe0-732f-924c-939023690013",
        "storage_key": "property/6767906449167599/019fc97a-8fe0-732f-924c-939023690013.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL8knm3TqwIcRRF_uuGyFlh8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_d54bdaa7-e40b-42b4-9e00-9c5bfa17face",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Burnt end BBQ - Desoto",
      "poi_type": "Restaurants",
      "poi_address": "34071 Commerce Dr, De Soto, KS 66018, USA",
      "poi_short_description": "Contemporary counter-service spot offering hickory-smoked barbecue, sides, housemade sauces & beer.",
      "poi_long_description": "Contemporary counter-service spot offering hickory-smoked barbecue, sides, housemade sauces & beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01016-fb7f-746e-b88d-e527cb3ef6f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01016-fb7f-746e-b88d-e527cb3ef6f2",
        "storage_key": "property/6767906449167599/01a01016-fb7f-746e-b88d-e527cb3ef6f2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://burntendbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14981278206256173120&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burnt-end-bbq---desoto",
      "poi_latitude": "38.961922",
      "poi_longitude": "-94.9787247",
      "poi_miles_from_property": "22.2",
      "poi_walking_minutes": "8 hours 11 mins",
      "poi_biking_minutes": "2 hours 11 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 913-884-1999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8fe0-732f-924c-939023690013.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8fe0-732f-924c-939023690013",
        "storage_key": "property/6767906449167599/019fc97a-8fe0-732f-924c-939023690013.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9YvuMwXAwIcRQFAzhScx6M8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0c985100-846c-4257-a8c9-ccec27e2dc7f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "J. Alexander's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "11471 Metcalf Ave, Overland Park, KS 66210, USA",
      "poi_short_description": "Restaurant chain serving wood-fired American fare in a contemporary space with a bar.",
      "poi_long_description": "Restaurant chain serving wood-fired American fare in a contemporary space with a bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01016-f97d-74e4-a5c0-4e5f8bfc5ba5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01016-f97d-74e4-a5c0-4e5f8bfc5ba5",
        "storage_key": "property/6767906449167599/01a01016-f97d-74e4-a5c0-4e5f8bfc5ba5.webp",
        "width": 1280,
        "height": 745
      },
      "poi_business_url": "https://jalexanders.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8471659785011343533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "j-alexanders-restaurant",
      "poi_latitude": "38.9180532",
      "poi_longitude": "-94.6665675",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-469-1995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8fe0-732f-924c-939023690013.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8fe0-732f-924c-939023690013",
        "storage_key": "property/6767906449167599/019fc97a-8fe0-732f-924c-939023690013.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpyLrYUDqwIcRrTCQj7BhkXU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_f079f84b-a984-43c5-b605-643f924915d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "La Fuente Mexican Street Food",
      "poi_type": "Restaurants",
      "poi_address": "10932 Stadium Dr, Kansas City, KS 66111, USA",
      "poi_short_description": "Fast-casual spot serving tacos and burritos, plus margaritas and beer.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01017-1a75-76b8-ba51-8afb05f43b47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-1a75-76b8-ba51-8afb05f43b47",
        "storage_key": "property/6767906449167599/01a01017-1a75-76b8-ba51-8afb05f43b47.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://legends.lafuentestreetfood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2955998026072478755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fuente-mexican-street-food",
      "poi_latitude": "39.1260725",
      "poi_longitude": "-94.8337757",
      "poi_miles_from_property": "23.4",
      "poi_walking_minutes": "8 hours 45 mins",
      "poi_biking_minutes": "2 hours 51 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 913-730-8620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8fe0-732f-924c-939023690013.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8fe0-732f-924c-939023690013",
        "storage_key": "property/6767906449167599/019fc97a-8fe0-732f-924c-939023690013.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJS24PVYCPwIcRI1TODIvQBSk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5b7986c3-2776-4e69-9f79-839f15245c4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Sickies Garage Burgers & Brews",
      "poi_type": "Restaurants",
      "poi_address": "7111 W 95th St, Overland Park, KS 66212, USA",
      "poi_short_description": "Casual spot with a car-garage vibe serving burgers (inc. unusual varieties), wings, nachos, fried pickles, onion rings, fries, chicken tenders, mozzarella sticks, macaroni and cheese, tater tots, deviled eggs and shakes, alongside beer and cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01017-0350-751b-a926-a6aa1a15192f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-0350-751b-a926-a6aa1a15192f",
        "storage_key": "property/6767906449167599/01a01017-0350-751b-a926-a6aa1a15192f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://sickiesburgers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7873372324216743774&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sickies-garage-burgers--brews",
      "poi_latitude": "38.9562268",
      "poi_longitude": "-94.6692154",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-491-4724",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8fe0-732f-924c-939023690013.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8fe0-732f-924c-939023690013",
        "storage_key": "property/6767906449167599/019fc97a-8fe0-732f-924c-939023690013.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx8Z1mUTrwIcRXqdU-WnWQ20",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_efa1abea-568e-41aa-8be6-1007ed82009e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "The Other Place Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "7324 W 80th St, Overland Park, KS 66204, USA",
      "poi_short_description": "Sports-themed pizzeria chain with TVs, plus a menu of pies, wings, beer & more.",
      "poi_long_description": "Sports-themed pizzeria chain with TVs, plus a menu of pies, wings, beer & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01016-fa0d-7035-941d-0459a5de61a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01016-fa0d-7035-941d-0459a5de61a8",
        "storage_key": "property/6767906449167599/01a01016-fa0d-7035-941d-0459a5de61a8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://theotherplace.com/location/overland-park-kansas",
      "poi_directions_map_url": "https://maps.google.com/?cid=5504879631191954700&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-other-place-overland-park",
      "poi_latitude": "38.9841287",
      "poi_longitude": "-94.6710351",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 913-652-9494",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8fe0-732f-924c-939023690013.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8fe0-732f-924c-939023690013",
        "storage_key": "property/6767906449167599/019fc97a-8fe0-732f-924c-939023690013.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJe37VXnHswIcRDNV6xNtCZUw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_4a507a34-f33b-4f5d-8aee-5a2ecc4439ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Strang Hall",
      "poi_type": "Restaurants",
      "poi_address": "7313 W 80th St, Overland Park, KS 66204, USA",
      "poi_short_description": "Industrial-chic food court with diverse eateries & outdoor tables on a grassy lawn.",
      "poi_long_description": "Industrial-chic food court with diverse eateries & outdoor tables on a grassy lawn.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01016-f8f9-7607-a537-949b06afc8dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01016-f8f9-7607-a537-949b06afc8dc",
        "storage_key": "property/6767906449167599/01a01016-f8f9-7607-a537-949b06afc8dc.webp",
        "width": 1215,
        "height": 911
      },
      "poi_business_url": "https://www.stranghall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1763956639910195457&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "strang-hall",
      "poi_latitude": "38.983876",
      "poi_longitude": "-94.6706021",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 913-701-7041",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8fe0-732f-924c-939023690013.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8fe0-732f-924c-939023690013",
        "storage_key": "property/6767906449167599/019fc97a-8fe0-732f-924c-939023690013.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl2WgU63twIcRAfEJ2TfVehg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_bc6ed88d-cdfa-412b-b667-d662acf80803",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Maggiano's Little Italy",
      "poi_type": "Restaurants",
      "poi_address": "7025 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Semi-upscale chain for classic Italian fare served family-style in a relaxed, polished space.",
      "poi_long_description": "Semi-upscale chain for classic Italian fare served family-style in a relaxed, polished space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01016-f9af-718d-b7a4-ee0fac56865e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01016-f9af-718d-b7a4-ee0fac56865e",
        "storage_key": "property/6767906449167599/01a01016-f9af-718d-b7a4-ee0fac56865e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.maggianos.com/locations/Kansas/Overland+Park/7025-w.-135th-street?utm_source=google&utm_medium=organic&utm_campaign=Maggianos",
      "poi_directions_map_url": "https://maps.google.com/?cid=8213715666550259878&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maggianos-little-italy",
      "poi_latitude": "38.883238",
      "poi_longitude": "-94.666864",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-897-8020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8fe0-732f-924c-939023690013.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8fe0-732f-924c-939023690013",
        "storage_key": "property/6767906449167599/019fc97a-8fe0-732f-924c-939023690013.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJS3qOvMLBwIcRpgDKbuH6_HE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_9c49cdcc-6f80-4dcb-aa62-9965033c0eed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Rock & Brews",
      "poi_type": "Restaurants",
      "poi_address": "5701 W 135th St, Overland Park, KS 66224, USA",
      "poi_short_description": "Brewery and chain of American grill eats such as burgers, hot wings, tacos, and pulled pork, plus a dog-friendly patio.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01016-fc5f-741d-832c-c272dd0d3211.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01016-fc5f-741d-832c-c272dd0d3211",
        "storage_key": "property/6767906449167599/01a01016-fc5f-741d-832c-c272dd0d3211.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "http://www.rockandbrews.com/overlandpark",
      "poi_directions_map_url": "https://maps.google.com/?cid=15053523993570692724&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rock--brews",
      "poi_latitude": "38.8832498",
      "poi_longitude": "-94.651677",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-544-1113",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8fe0-732f-924c-939023690013.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8fe0-732f-924c-939023690013",
        "storage_key": "property/6767906449167599/019fc97a-8fe0-732f-924c-939023690013.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ99afOPfBwIcRdM6ZrlDc6NA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewpub"
    },
    {
      "id": "custom_4f4d18ee-5311-4368-8c66-9e73a38e1b71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Firebirds Wood Fired Grill",
      "poi_type": "Restaurants",
      "poi_address": "6601 W 135th St Ste A9, Overland Park, KS 66223, USA",
      "poi_short_description": "Chain restaurant serving steaks, seafood & cocktails in an upscale lodgelike setting.",
      "poi_long_description": "Chain restaurant serving steaks, seafood & cocktails in an upscale lodgelike setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01016-fd7f-76be-83a2-c4f05909cd1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01016-fd7f-76be-83a2-c4f05909cd1f",
        "storage_key": "property/6767906449167599/01a01016-fd7f-76be-83a2-c4f05909cd1f.webp",
        "width": 1000,
        "height": 671
      },
      "poi_business_url": "https://firebirdsrestaurants.com/overland-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13933799802866275182&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "firebirds-wood-fired-grill",
      "poi_latitude": "38.881538",
      "poi_longitude": "-94.6619424",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-202-1761",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8fe0-732f-924c-939023690013.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8fe0-732f-924c-939023690013",
        "storage_key": "property/6767906449167599/019fc97a-8fe0-732f-924c-939023690013.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwUErqenBwIcRbpNApRjNXsE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_eb3ccfab-b67e-452e-a808-727d8b9e0b3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Chicken N Pickle - Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "5901 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Family-friendly venue with pickleball courts and other games, plus a casual restaurant.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97d-b3b3-7095-9b4f-107a010635e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-b3b3-7095-9b4f-107a010635e1",
        "storage_key": "property/6767906449167599/019fc97d-b3b3-7095-9b4f-107a010635e1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://chickennpickle.com/location/overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3904135511973972812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chicken-n-pickle---overland-park",
      "poi_latitude": "38.8830518",
      "poi_longitude": "-94.6552102",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-703-5950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8fe0-732f-924c-939023690013.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8fe0-732f-924c-939023690013",
        "storage_key": "property/6767906449167599/019fc97a-8fe0-732f-924c-939023690013.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ9D8rijBwIcRTEsyKpBGLjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_6a480ee5-b521-4729-9a10-6302ae55ee70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Hen House Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "6900 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Casual market, deli and supermarket with fresh produce and a large meat section along with a florist, a bakery, a cafe, prepared foods and bagels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01016-ff44-7300-bb45-c5b7505ac765.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01016-ff44-7300-bb45-c5b7505ac765",
        "storage_key": "property/6767906449167599/01a01016-ff44-7300-bb45-c5b7505ac765.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "http://henhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3407519095472349622&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hen-house-market",
      "poi_latitude": "38.8856924",
      "poi_longitude": "-94.6657055",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-685-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-9048-70f3-bbf8-4b5ea0549261.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-9048-70f3-bbf8-4b5ea0549261",
        "storage_key": "property/6767906449167599/019fc97a-9048-70f3-bbf8-4b5ea0549261.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIbLSX93BwIcRtmH9QpDwSS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_7f2fc987-e201-4c59-b4d8-bf4d1f4cec01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Deer Creek Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "Deer Creek Marketplace, Overland Park, KS, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9860517788264761128&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deer-creek-marketplace",
      "poi_latitude": "38.8849553",
      "poi_longitude": "-94.6650567",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-908a-7033-ac8c-6933f453d6bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-908a-7033-ac8c-6933f453d6bf",
        "storage_key": "property/6767906449167599/019fc97a-908a-7033-ac8c-6933f453d6bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8eIFYN3BwIcRKAfxZq-Y14g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_303e844d-0ea5-4bab-acc0-68c2f90bdaec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Corbin Park",
      "poi_type": "Shopping & Retail",
      "poi_address": "6917 W 135th St #29, Overland Park, KS 66223, USA",
      "poi_short_description": "Upscale shopping mall offering a department store, an organic grocer, furnishings & restaurants.",
      "poi_long_description": "Upscale shopping mall offering a department store, an organic grocer, furnishings & restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01016-ff9b-7509-8e0e-6e755cd5d0bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01016-ff9b-7509-8e0e-6e755cd5d0bf",
        "storage_key": "property/6767906449167599/01a01016-ff9b-7509-8e0e-6e755cd5d0bf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.corbinparkop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5069566010625269083&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corbin-park",
      "poi_latitude": "38.88257",
      "poi_longitude": "-94.6630357",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-499-1926",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8f65-73ca-b90e-d449312a7350.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8f65-73ca-b90e-d449312a7350",
        "storage_key": "property/6767906449167599/019fc97a-8f65-73ca-b90e-d449312a7350.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJK3wCC-nBwIcRW522TG23WkY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_552deea4-dc35-4d8f-9f18-572c9010fa36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Batteries Plus",
      "poi_type": "Shopping & Retail",
      "poi_address": "13408 Metcalf Ave, Overland Park, KS 66213, USA",
      "poi_short_description": "Chain selling batteries for watches, phones & vehicles, plus replacement lightbulbs.",
      "poi_long_description": "Chain selling batteries for watches, phones & vehicles, plus replacement lightbulbs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01017-0120-76dc-9617-e1166868b95a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-0120-76dc-9617-e1166868b95a",
        "storage_key": "property/6767906449167599/01a01017-0120-76dc-9617-e1166868b95a.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "https://www.batteriesplus.com/store-locator/ks/overland-park/batteries-plus-282?utm_source=gmb&utm_medium=local&utm_campaign=bpb&storecode=282",
      "poi_directions_map_url": "https://maps.google.com/?cid=4524551017350385294&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "batteries-plus",
      "poi_latitude": "38.8850535",
      "poi_longitude": "-94.6682686",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-897-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8f65-73ca-b90e-d449312a7350.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8f65-73ca-b90e-d449312a7350",
        "storage_key": "property/6767906449167599/019fc97a-8f65-73ca-b90e-d449312a7350.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ75bjG93BwIcRjk5NnS1vyj4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "auto_parts_store"
    },
    {
      "id": "custom_038c32ec-9a06-45dc-93b6-6654dec9d3d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "8000 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01017-01c5-767f-80c4-69427c3f6876.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-01c5-767f-80c4-69427c3f6876",
        "storage_key": "property/6767906449167599/01a01017-01c5-767f-80c4-69427c3f6876.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/S-Overland-Park/KS/Overland-Park/66223/2209?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=4486289742864269163&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "38.8858362",
      "poi_longitude": "-94.679321",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-851-9961",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8f65-73ca-b90e-d449312a7350.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8f65-73ca-b90e-d449312a7350",
        "storage_key": "property/6767906449167599/019fc97a-8f65-73ca-b90e-d449312a7350.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJfb8SAs7BwIcRaz_ncsCAQj4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_3b0eb557-bc25-4eb6-b33b-7e23b24a16b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "12221 Blue Valley Pkwy, Overland Park, KS 66213, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97d-dfeb-74a8-a925-2fd0d9c51a73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-dfeb-74a8-a925-2fd0d9c51a73",
        "storage_key": "property/6767906449167599/019fc97d-dfeb-74a8-a925-2fd0d9c51a73.webp",
        "width": 1280,
        "height": 518
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/overland-park-KS-369.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=12181420978670501186&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "38.9065093",
      "poi_longitude": "-94.6707763",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-217-2050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8f65-73ca-b90e-d449312a7350.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8f65-73ca-b90e-d449312a7350",
        "storage_key": "property/6767906449167599/019fc97a-8f65-73ca-b90e-d449312a7350.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJg8cveG7qwIcRQn0lFdcZDak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_cf3a2aff-0529-4372-b741-98941e7d7668",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "11701 Metcalf Ave, Overland Park, KS 66210, USA",
      "poi_short_description": "Department store chain with clothing, electronics, and home goods, plus groceries, and pharmacy services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97d-c8c8-71c9-88ce-a531312fe38a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-c8c8-71c9-88ce-a531312fe38a",
        "storage_key": "property/6767906449167599/019fc97d-c8c8-71c9-88ce-a531312fe38a.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1599-overland-park-ks/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=9310956249863213418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "38.91484750000001",
      "poi_longitude": "-94.6638388",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-338-2202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8f65-73ca-b90e-d449312a7350.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8f65-73ca-b90e-d449312a7350",
        "storage_key": "property/6767906449167599/019fc97a-8f65-73ca-b90e-d449312a7350.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJPwmyQxXqwIcRatFMsGApN4E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_3d1a13bd-173d-4e7c-a371-d258e0c62d90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Town Center Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "5000 W 119th St, Leawood, KS 66209, USA",
      "poi_short_description": "Open-air shopping hub with higher-end fashion & lifestyle stores, plus many restaurants & a cinema.",
      "poi_long_description": "Open-air shopping hub with higher-end fashion & lifestyle stores, plus many restaurants & a cinema.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01017-02f2-74aa-a11d-3d03b2ec2aec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-02f2-74aa-a11d-3d03b2ec2aec",
        "storage_key": "property/6767906449167599/01a01017-02f2-74aa-a11d-3d03b2ec2aec.webp",
        "width": 1280,
        "height": 783
      },
      "poi_business_url": "https://towncenterplaza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11425486666686205015&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "town-center-plaza",
      "poi_latitude": "38.9148371",
      "poi_longitude": "-94.6443996",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-498-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8f65-73ca-b90e-d449312a7350.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8f65-73ca-b90e-d449312a7350",
        "storage_key": "property/6767906449167599/019fc97a-8f65-73ca-b90e-d449312a7350.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJHUfgZ_XpwIcRVwzLqZZ7j54",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_9169de71-be94-4193-8cef-eddb3838f5f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Oak Park Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "11149 W 95th St, Overland Park, KS 66214, USA",
      "poi_short_description": "Busy, long-standing indoor shopping destination with 2 levels of popular brands & a food court.",
      "poi_long_description": "Busy, long-standing indoor shopping destination with 2 levels of popular brands & a food court.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019ff6b5-839e-753f-b319-c1459c0bc333.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b5-839e-753f-b319-c1459c0bc333",
        "storage_key": "property/6767906449167599/019ff6b5-839e-753f-b319-c1459c0bc333.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.shopoakparkmall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3751688215534709327&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-park-mall",
      "poi_latitude": "38.9530939",
      "poi_longitude": "-94.7196254",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-888-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8f65-73ca-b90e-d449312a7350.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8f65-73ca-b90e-d449312a7350",
        "storage_key": "property/6767906449167599/019fc97a-8f65-73ca-b90e-d449312a7350.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJzVbG9zXrwIcRTyr3Ao6sEDQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_5bd90ffa-b95a-4ee0-85cb-4f28522ce34c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Overland Trail Elementary School",
      "poi_type": "Education",
      "poi_address": "6225 W 133rd St, Overland Park, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97d-f81d-750d-88d8-f41614d3371f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-f81d-750d-88d8-f41614d3371f",
        "storage_key": "property/6767906449167599/019fc97d-f81d-750d-88d8-f41614d3371f.webp",
        "width": 1280,
        "height": 861
      },
      "poi_business_url": "https://www.bluevalleyk12.org/OTE",
      "poi_directions_map_url": "https://maps.google.com/?cid=2244344860322751896&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-trail-elementary-school",
      "poi_latitude": "38.88582210000001",
      "poi_longitude": "-94.6575254",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-239-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8fc6-7793-830c-d8e140afe810.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8fc6-7793-830c-d8e140afe810",
        "storage_key": "property/6767906449167599/019fc97a-8fc6-7793-830c-d8e140afe810.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJy1sTYGPwIcRmOUCacKDJR8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_92a55046-4764-41d8-aafc-cf89bb529441",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Overland Trail Middle School",
      "poi_type": "Education",
      "poi_address": "6201 W 133rd St, Overland Park, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97d-f50c-744e-9b9a-c23073d96fb8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97d-f50c-744e-9b9a-c23073d96fb8",
        "storage_key": "property/6767906449167599/019fc97d-f50c-744e-9b9a-c23073d96fb8.webp",
        "width": 1280,
        "height": 543
      },
      "poi_business_url": "https://www.bluevalleyk12.org/OTM",
      "poi_directions_map_url": "https://maps.google.com/?cid=15599445353126869038&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-trail-middle-school",
      "poi_latitude": "38.8855363",
      "poi_longitude": "-94.6545605",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-239-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8fc6-7793-830c-d8e140afe810.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8fc6-7793-830c-d8e140afe810",
        "storage_key": "property/6767906449167599/019fc97a-8fc6-7793-830c-d8e140afe810.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJy1sTYGPwIcRLrg-NuZcfNg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_24094a7a-60ae-4755-8583-0467d2156795",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Valley Park Elementary School",
      "poi_type": "Education",
      "poi_address": "12301 Lamar Ave, Overland Park, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bluevalleyk12.org/vpe",
      "poi_directions_map_url": "https://maps.google.com/?cid=9356314748604894902&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valley-park-elementary-school",
      "poi_latitude": "38.9051188",
      "poi_longitude": "-94.6573811",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-239-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8fc6-7793-830c-d8e140afe810.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8fc6-7793-830c-d8e140afe810",
        "storage_key": "property/6767906449167599/019fc97a-8fc6-7793-830c-d8e140afe810.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM_W9fjHqwIcRts5XJbFO2IE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_bf3c664b-1f61-4797-a706-55aa0854c140",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Blue Valley North High School",
      "poi_type": "Education",
      "poi_address": "12200 Lamar Ave, Overland Park, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97e-103d-72ba-a8d3-0ff9b9c610b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97e-103d-72ba-a8d3-0ff9b9c610b1",
        "storage_key": "property/6767906449167599/019fc97e-103d-72ba-a8d3-0ff9b9c610b1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bluevalleyk12.org/bvn",
      "poi_directions_map_url": "https://maps.google.com/?cid=15101532817909822492&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-valley-north-high-school",
      "poi_latitude": "38.9068618",
      "poi_longitude": "-94.6604547",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-239-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8fc6-7793-830c-d8e140afe810.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8fc6-7793-830c-d8e140afe810",
        "storage_key": "property/6767906449167599/019fc97a-8fc6-7793-830c-d8e140afe810.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoROKIBLqwIcRHDRrJxZsk9E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_eac1d95e-1f5f-4a8e-ad1c-9ce56bf98e68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Blue Valley Northwest High School",
      "poi_type": "Education",
      "poi_address": "13260 Switzer Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01017-0615-70fe-8d49-c3521a3927ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-0615-70fe-8d49-c3521a3927ad",
        "storage_key": "property/6767906449167599/01a01017-0615-70fe-8d49-c3521a3927ad.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.bluevalleyk12.org/bvnw",
      "poi_directions_map_url": "https://maps.google.com/?cid=665158985377803435&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-valley-northwest-high-school",
      "poi_latitude": "38.8885806",
      "poi_longitude": "-94.7032351",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-239-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8fc6-7793-830c-d8e140afe810.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8fc6-7793-830c-d8e140afe810",
        "storage_key": "property/6767906449167599/019fc97a-8fc6-7793-830c-d8e140afe810.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBevbQCHAwIcRq2yaspIeOwk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_4a841979-29bb-4bdd-ad7e-d84684c94e00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "The Learning Experience - Blue Valley",
      "poi_type": "Education",
      "poi_address": "7021 W 121st St, Overland Park, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01017-05aa-714f-90bc-ab6d18fb06c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-05aa-714f-90bc-ab6d18fb06c5",
        "storage_key": "property/6767906449167599/01a01017-05aa-714f-90bc-ab6d18fb06c5.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://thelearningexperience.com/centers/blue-valley/?utm_source=google&utm_medium=organic&utm_campaign=gbp_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=18414937019138631416&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-learning-experience---blue-valley",
      "poi_latitude": "38.907787",
      "poi_longitude": "-94.667218",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-283-7580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8fc6-7793-830c-d8e140afe810.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8fc6-7793-830c-d8e140afe810",
        "storage_key": "property/6767906449167599/019fc97a-8fc6-7793-830c-d8e140afe810.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZWc-CzXrwIcR-ObyAqf_jv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_3ed0a5ce-1fa9-42c8-ad5a-f05c0fec97c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Canterbury Academy",
      "poi_type": "Education",
      "poi_address": "6820 W 121st St, Overland Park, KS 66209, USA",
      "poi_short_description": "Day nursery featuring programs for infants, toddlers and preschool- to school-age kids.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01017-072f-74ee-9d38-ab7bfad1c88a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-072f-74ee-9d38-ab7bfad1c88a",
        "storage_key": "property/6767906449167599/01a01017-072f-74ee-9d38-ab7bfad1c88a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cadence-education.com/locations/ks/overland-park/885?utm_source=google&utm_medium=local_listing&utm_campaign=local_seo",
      "poi_directions_map_url": "https://maps.google.com/?cid=928007796110134348&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "canterbury-academy",
      "poi_latitude": "38.9090413",
      "poi_longitude": "-94.6635225",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-808-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8fc6-7793-830c-d8e140afe810.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8fc6-7793-830c-d8e140afe810",
        "storage_key": "property/6767906449167599/019fc97a-8fc6-7793-830c-d8e140afe810.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6xpwDBPqwIcRTAzweyzy4Aw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_c876403b-c8cc-460e-b430-98d09b9c7c55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "The Goddard School of Overland Park - Metcalf",
      "poi_type": "Education",
      "poi_address": "14330 Metcalf Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01017-099d-75f1-b361-62ae09f0e812.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-099d-75f1-b361-62ae09f0e812",
        "storage_key": "property/6767906449167599/01a01017-099d-75f1-b361-62ae09f0e812.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.goddardschool.com/schools/ks/overland-park/overland-park-metcalf?utm_source=google&utm_medium=business_listings&utm_campaign=school&utm_content=main_button",
      "poi_directions_map_url": "https://maps.google.com/?cid=400174484588065119&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-goddard-school-of-overland-park---metcalf",
      "poi_latitude": "38.86808000000001",
      "poi_longitude": "-94.669367",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-681-1610",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8fc6-7793-830c-d8e140afe810.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8fc6-7793-830c-d8e140afe810",
        "storage_key": "property/6767906449167599/019fc97a-8fc6-7793-830c-d8e140afe810.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq_pyJLzBwIcRX_EL0pK0jQU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_855fd72a-3f70-4986-947f-333399ff96a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Johnson County Community College",
      "poi_type": "Education",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-006d-7522-9fd3-524b8ce8e311.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97a-006d-7522-9fd3-524b8ce8e311",
        "storage_key": "property/6767906449167599/019fc97a-006d-7522-9fd3-524b8ce8e311.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.jccc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4939079639992649295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-community-college",
      "poi_latitude": "38.9237619",
      "poi_longitude": "-94.7303185",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-469-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8fc6-7793-830c-d8e140afe810.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8fc6-7793-830c-d8e140afe810",
        "storage_key": "property/6767906449167599/019fc97a-8fc6-7793-830c-d8e140afe810.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEejhg2TrwIcRT0Ygo8Mii0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b50b053a-d74a-49b3-969a-93a728a1481c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Hiersteiner Child Development Center",
      "poi_type": "Education",
      "poi_address": "66210 S Campus Dr, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.jccc.edu/campus-life/childcare/",
      "poi_directions_map_url": "https://maps.google.com/?cid=234373460621827390&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hiersteiner-child-development-center",
      "poi_latitude": "38.9232807",
      "poi_longitude": "-94.7351434",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-469-4438",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8fc6-7793-830c-d8e140afe810.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8fc6-7793-830c-d8e140afe810",
        "storage_key": "property/6767906449167599/019fc97a-8fc6-7793-830c-d8e140afe810.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZSeSKS6VwIcRPp0ksWupQAM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_bd84d84e-fa5f-454e-b188-4a752b47acfb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "AMC Prairiefire 17",
      "poi_type": "Entertainment",
      "poi_address": "5724 W 136th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Comfortable entertainment venue featuring a full menu alongside movie screenings of new releases.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019ff6b8-b7d1-7124-8df2-6c22c3c539c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b8-b7d1-7124-8df2-6c22c3c539c4",
        "storage_key": "property/6767906449167599/019ff6b8-b7d1-7124-8df2-6c22c3c539c4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/kansas-city/amc-prairiefire-17?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3727223515720771879&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-prairiefire-17",
      "poi_latitude": "38.8826984",
      "poi_longitude": "-94.651566",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-553-3075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97f-a31e-727a-99db-98ca0f37cb07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97f-a31e-727a-99db-98ca0f37cb07",
        "storage_key": "property/6767906449167599/019fc97f-a31e-727a-99db-98ca0f37cb07.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7fXu5_DBwIcRJ-kENQrCuTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_36d64faa-9aa2-4266-9e4c-956312603e62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "B&B Theatres Overland Park 16",
      "poi_type": "Entertainment",
      "poi_address": "8601 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Relaxed, contemporary multiscreen theater featuring showings of mainstream films.",
      "poi_long_description": "Relaxed, contemporary multiscreen theater featuring showings of mainstream films.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01017-0a49-7354-9305-699f42300b54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-0a49-7354-9305-699f42300b54",
        "storage_key": "property/6767906449167599/01a01017-0a49-7354-9305-699f42300b54.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "https://www.bbtheatres.com/our-theatres/x0uvh-b-and-b-overland-park-16/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6259761698616561138&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bb-theatres-overland-park-16",
      "poi_latitude": "38.8812512",
      "poi_longitude": "-94.6835183",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-871-5352",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97f-a31e-727a-99db-98ca0f37cb07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97f-a31e-727a-99db-98ca0f37cb07",
        "storage_key": "property/6767906449167599/019fc97f-a31e-727a-99db-98ca0f37cb07.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJDWO_qc3BwIcR8s2iaBkk31Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_eeb2c96f-0297-48c2-8ea2-20fca027afb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Museum at Prairiefire",
      "poi_type": "Entertainment",
      "poi_address": "5801 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_long_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-1ef5-7176-a805-d6e8cc6f0394.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97a-1ef5-7176-a805-d6e8cc6f0394",
        "storage_key": "property/6767906449167599/019fc97a-1ef5-7176-a805-d6e8cc6f0394.webp",
        "width": 1170,
        "height": 797
      },
      "poi_business_url": "https://www.visitthemap.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9011883457387750483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-at-prairiefire",
      "poi_latitude": "38.8819446",
      "poi_longitude": "-94.6520905",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-333-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8fcb-735c-bbfe-9ccaafeadcc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8fcb-735c-bbfe-9ccaafeadcc7",
        "storage_key": "property/6767906449167599/019fc97a-8fcb-735c-bbfe-9ccaafeadcc7.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJOdDvHPHBwIcRU-TQ6kGkEH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_63d3fb43-384a-4035-ab3e-3d186250dfc7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "AMC Town Center 20",
      "poi_type": "Entertainment",
      "poi_address": "11701 Nall Ave, Leawood, KS 66211, USA",
      "poi_short_description": "Modern cinema equipped with comfy seats, luxury recliners, and a snack bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97e-57bc-7678-85f5-c202c4592130.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97e-57bc-7678-85f5-c202c4592130",
        "storage_key": "property/6767906449167599/019fc97e-57bc-7678-85f5-c202c4592130.webp",
        "width": 1280,
        "height": 783
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/kansas-city/amc-town-center-20?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=2804340900304979407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-town-center-20",
      "poi_latitude": "38.915838",
      "poi_longitude": "-94.648325",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-498-8696",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97f-a31e-727a-99db-98ca0f37cb07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97f-a31e-727a-99db-98ca0f37cb07",
        "storage_key": "property/6767906449167599/019fc97f-a31e-727a-99db-98ca0f37cb07.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6xgReh_qwIcRzwXH1zAF6yY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_93d0a5aa-3f81-46a1-bec1-c7a1c0d14e27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Deanna Rose Children's Farmstead",
      "poi_type": "Entertainment",
      "poi_address": "13800 Switzer Rd, Overland Park, KS 66221, USA",
      "poi_short_description": "Spacious farmstead featuring replicas of life on the prairie, an ice cream parlor & wagon rides.",
      "poi_long_description": "Spacious farmstead featuring replicas of life on the prairie, an ice cream parlor & wagon rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97e-54b0-73ee-860c-4fb9f26e437f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97e-54b0-73ee-860c-4fb9f26e437f",
        "storage_key": "property/6767906449167599/019fc97e-54b0-73ee-860c-4fb9f26e437f.webp",
        "width": 640,
        "height": 349
      },
      "poi_business_url": "http://www.opkansas.org/things-to-see-and-do/deanna-rose-childrens-farmstead/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7835830010939554497&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deanna-rose-childrens-farmstead",
      "poi_latitude": "38.877729",
      "poi_longitude": "-94.703345",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-897-2360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-908a-7033-ac8c-6933f453d6bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-908a-7033-ac8c-6933f453d6bf",
        "storage_key": "property/6767906449167599/019fc97a-908a-7033-ac8c-6933f453d6bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt6IUwjvAwIcRwbplAuF1vmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_df10131b-fec5-4168-bdcf-537b2c141b6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Overland Park Arboretum & Botanical Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8909 W 179th St, Overland Park, KS 66013, USA",
      "poi_short_description": "Gardens, trails & recreation areas plus educational programs & events on environmental issues.",
      "poi_long_description": "Gardens, trails & recreation areas plus educational programs & events on environmental issues.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97f-299b-75a8-9013-17cadb05e80b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97f-299b-75a8-9013-17cadb05e80b",
        "storage_key": "property/6767906449167599/019fc97f-299b-75a8-9013-17cadb05e80b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.opkansas.org/recreation-fun/arboretum-botanical-gardens/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8713039177416778041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-arboretum--botanical-gardens",
      "poi_latitude": "38.8033925",
      "poi_longitude": "-94.6891159",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-685-3604",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-908a-7033-ac8c-6933f453d6bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-908a-7033-ac8c-6933f453d6bf",
        "storage_key": "property/6767906449167599/019fc97a-908a-7033-ac8c-6933f453d6bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6csjvynHwIcROSH92_fu6ng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_e9b16d98-5efa-4fba-a91c-f5528c877cf0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Nerman Museum of Contemporary Art",
      "poi_type": "Entertainment",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "Johnson County Community College's modern-art facility including an auditorium, cafe & classrooms.",
      "poi_long_description": "Johnson County Community College's modern-art facility including an auditorium, cafe & classrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-1bce-771e-b7b2-d5eb7120e56d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97a-1bce-771e-b7b2-d5eb7120e56d",
        "storage_key": "property/6767906449167599/019fc97a-1bce-771e-b7b2-d5eb7120e56d.webp",
        "width": 1080,
        "height": 830
      },
      "poi_business_url": "http://www.nermanmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4973184191241098516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nerman-museum-of-contemporary-art",
      "poi_latitude": "38.924852",
      "poi_longitude": "-94.726824",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-469-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8fcb-735c-bbfe-9ccaafeadcc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8fcb-735c-bbfe-9ccaafeadcc7",
        "storage_key": "property/6767906449167599/019fc97a-8fcb-735c-bbfe-9ccaafeadcc7.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVtOx9LqwIcRFJWDQaxMBEU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_96e0eda5-6126-470a-bada-e887171c1ffb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Topgolf Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "10611 Nall Ave, Overland Park, KS 66207, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-0fb3-773e-91c0-fd78ea7eac04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97a-0fb3-773e-91c0-fd78ea7eac04",
        "storage_key": "property/6767906449167599/019fc97a-0fb3-773e-91c0-fd78ea7eac04.webp",
        "width": 1280,
        "height": 884
      },
      "poi_business_url": "https://topgolf.com/us/overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4737452325202402593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-overland-park",
      "poi_latitude": "38.9364597",
      "poi_longitude": "-94.64818",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-562-9713",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8fe0-732f-924c-939023690013.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8fe0-732f-924c-939023690013",
        "storage_key": "property/6767906449167599/019fc97a-8fe0-732f-924c-939023690013.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJibz1RyvqwIcRIZ0JKMrPvkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_df28a9c6-b190-45b6-bf8e-d8ea03150459",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Andretti Indoor Karting & Games Overland Park",
      "poi_type": "Entertainment",
      "poi_address": "11610 Nall Ave, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019ff6b8-bbc5-72eb-92dc-f076a76f798a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b8-bbc5-72eb-92dc-f076a76f798a",
        "storage_key": "property/6767906449167599/019ff6b8-bbc5-72eb-92dc-f076a76f798a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://andrettikarting.com/overlandpark",
      "poi_directions_map_url": "https://maps.google.com/?cid=12146707873347930037&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "andretti-indoor-karting--games-overland-park",
      "poi_latitude": "38.91818490000001",
      "poi_longitude": "-94.6498735",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-937-4201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-908a-7033-ac8c-6933f453d6bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-908a-7033-ac8c-6933f453d6bf",
        "storage_key": "property/6767906449167599/019fc97a-908a-7033-ac8c-6933f453d6bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx1VUXQDrwIcRtQdYbXTGkag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_5cbbb27d-1d52-4d0d-9777-6fd26e25af29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Starlight Theatre",
      "poi_type": "Entertainment",
      "poi_address": "4600 Starlight Rd, Kansas City, MO 64132, USA",
      "poi_short_description": "Iconic outdoor theater in Swope Park hosting Broadway shows, rock concerts & other productions.",
      "poi_long_description": "Iconic outdoor theater in Swope Park hosting Broadway shows, rock concerts & other productions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01017-0ce2-77da-bf68-bf95c352554f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-0ce2-77da-bf68-bf95c352554f",
        "storage_key": "property/6767906449167599/01a01017-0ce2-77da-bf68-bf95c352554f.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "https://www.kcstarlight.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12152994064738864795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starlight-theatre",
      "poi_latitude": "39.00745440000001",
      "poi_longitude": "-94.5328221",
      "poi_miles_from_property": "13.7",
      "poi_walking_minutes": "5 hours 4 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 816-363-7827",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-908a-7033-ac8c-6933f453d6bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-908a-7033-ac8c-6933f453d6bf",
        "storage_key": "property/6767906449167599/019fc97a-908a-7033-ac8c-6933f453d6bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg_zL1bnlwIcRm84warYbqKg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_9ccda9a6-7896-4658-b018-f6ae46a44d09",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Saint Luke's South Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "12300 Metcalf Ave, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97e-6970-73cf-90f0-4f3eab543791.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97e-6970-73cf-90f0-4f3eab543791",
        "storage_key": "property/6767906449167599/019fc97e-6970-73cf-90f0-4f3eab543791.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.saintlukeskc.org/locations/saint-lukes-south-hospital?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=8966224544508452770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-lukes-south-hospital",
      "poi_latitude": "38.9041982",
      "poi_longitude": "-94.6695167",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-317-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8f70-72d3-9bdd-f0591c9b2381.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8f70-72d3-9bdd-f0591c9b2381",
        "storage_key": "property/6767906449167599/019fc97a-8f70-72d3-9bdd-f0591c9b2381.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJkT2aF3LqwIcRop_Q17dtbnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_101805bf-718e-4799-a9dc-fb8320b3e139",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Menorah Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "5721 W 119th St, Overland Park, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-4e3b-7218-830d-79e633de4f1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97a-4e3b-7218-830d-79e633de4f1e",
        "storage_key": "property/6767906449167599/019fc97a-4e3b-7218-830d-79e633de4f1e.webp",
        "width": 1280,
        "height": 983
      },
      "poi_business_url": "https://www.hcamidwest.com/locations/menorah-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13288974551408218760&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "menorah-medical-center",
      "poi_latitude": "38.9108041",
      "poi_longitude": "-94.6515422",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-498-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8f70-72d3-9bdd-f0591c9b2381.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8f70-72d3-9bdd-f0591c9b2381",
        "storage_key": "property/6767906449167599/019fc97a-8f70-72d3-9bdd-f0591c9b2381.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJa9T6FxnqwIcRiJLkTfLra7g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_ffa153fb-d233-4418-a8d0-334dde6b4291",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "CareNow Urgent Care - Corbin Park",
      "poi_type": "Health and Wellness",
      "poi_address": "13761 Metcalf Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019ff6b8-bac8-77fe-b8d9-6992588a4955.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b8-bac8-77fe-b8d9-6992588a4955",
        "storage_key": "property/6767906449167599/019ff6b8-bac8-77fe-b8d9-6992588a4955.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.carenow.com/locations/kansas-city/corbin-park?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=17803688775260742105&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---corbin-park",
      "poi_latitude": "38.87859419999999",
      "poi_longitude": "-94.6672924",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-814-3788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-908a-7033-ac8c-6933f453d6bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-908a-7033-ac8c-6933f453d6bf",
        "storage_key": "property/6767906449167599/019fc97a-908a-7033-ac8c-6933f453d6bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX1b2mqnBwIcR2aEG9ZxoE_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_42ee8a0e-318a-4f9c-812c-279c78d412d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "MinuteClinic at CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "11900 W 135th St, Overland Park, KS 66221, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01017-0d2f-75d9-92e7-69116c6c46da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-0d2f-75d9-92e7-69116c6c46da",
        "storage_key": "property/6767906449167599/01a01017-0d2f-75d9-92e7-69116c6c46da.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.cvs.com/minuteclinic/clinic-locator/ks/overland-park/8573.html?WT.mc_id=LS_mc_google_carenav_8573",
      "poi_directions_map_url": "https://maps.google.com/?cid=9936929295252049910&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "minuteclinic-at-cvs",
      "poi_latitude": "38.88672529999999",
      "poi_longitude": "-94.7244414",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 866-389-2727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-908a-7033-ac8c-6933f453d6bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-908a-7033-ac8c-6933f453d6bf",
        "storage_key": "property/6767906449167599/019fc97a-908a-7033-ac8c-6933f453d6bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyUNvQwbAwIcR9s-rwYsQ54k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_8999dbe4-0b3e-4aea-a900-76169bc2a4bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Apotheco Pharmacy Overland Park",
      "poi_type": "Health and Wellness",
      "poi_address": "6407 W 119th St g5, Overland Park, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01017-0f98-72b9-996c-b794e2805b22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-0f98-72b9-996c-b794e2805b22",
        "storage_key": "property/6767906449167599/01a01017-0f98-72b9-996c-b794e2805b22.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.apothecopharmacy.com/location/apotheco-pharmacy-overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4332067123779148834&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "apotheco-pharmacy-overland-park",
      "poi_latitude": "38.9119281",
      "poi_longitude": "-94.6599738",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-307-1730",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97f-a3c8-77c9-b046-1a3bce18dc01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97f-a3c8-77c9-b046-1a3bce18dc01",
        "storage_key": "property/6767906449167599/019fc97f-a3c8-77c9-b046-1a3bce18dc01.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJozy2HSvrwIcRIhwByBiYHjw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_9d759c2e-36dd-4ccd-95ef-784018dd3347",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "6800 138th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Upscale gym with a spa, an indoor and an outdoor pool, plus a hair salon.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-2775-709b-a52e-1c3e5c87c4a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97a-2775-709b-a52e-1c3e5c87c4a1",
        "storage_key": "property/6767906449167599/019fc97a-2775-709b-a52e-1c3e5c87c4a1.webp",
        "width": 1200,
        "height": 627
      },
      "poi_business_url": "https://www.lifetime.life/locations/ks/overland-park?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=6007822183813280658&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "38.8789466",
      "poi_longitude": "-94.6645722",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-239-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-908a-7033-ac8c-6933f453d6bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-908a-7033-ac8c-6933f453d6bf",
        "storage_key": "property/6767906449167599/019fc97a-908a-7033-ac8c-6933f453d6bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeyRfIerBwIcRkvPmA3ISYFM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_e7100798-4e48-430d-97ee-c0252a61d622",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "11411 Metcalf Ave, Overland Park, KS 66210, USA",
      "poi_short_description": "Chain gym with a membership requirement offering tanning and plenty of equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-2b18-725d-ad35-32ee41467325.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97a-2b18-725d-ad35-32ee41467325",
        "storage_key": "property/6767906449167599/019fc97a-2b18-725d-ad35-32ee41467325.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/overland-park-metcalf-ks?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=10468351881021403037&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "38.9194305",
      "poi_longitude": "-94.6658236",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-788-6960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-908a-7033-ac8c-6933f453d6bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-908a-7033-ac8c-6933f453d6bf",
        "storage_key": "property/6767906449167599/019fc97a-908a-7033-ac8c-6933f453d6bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3xUhl9DrwIcRna8SdJIOR5E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_82a59ed3-31a8-41e4-a6cf-cc4f5b345f0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "13621 Metcalf Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "Heart rate–based, calorie-burning studio featuring group classes and workouts that can be tracked in real-time.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97e-ae88-7107-84c6-84efe62a0ead.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97e-ae88-7107-84c6-84efe62a0ead",
        "storage_key": "property/6767906449167599/019fc97e-ae88-7107-84c6-84efe62a0ead.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/kansas/overland-park/13621-metcalf-ave/?utm_medium=seo&utm_source=gg&utm_term=tombras&utm_campaign=reputationdotcom--National",
      "poi_directions_map_url": "https://maps.google.com/?cid=2517780848240473361&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "38.8814048",
      "poi_longitude": "-94.6672773",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-213-1012",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-908a-7033-ac8c-6933f453d6bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-908a-7033-ac8c-6933f453d6bf",
        "storage_key": "property/6767906449167599/019fc97a-908a-7033-ac8c-6933f453d6bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz2AK5sLBwIcREbWneVf08CI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_82475090-0e3f-440e-8b25-f80a4b9aa554",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "YogaSix Overland Park",
      "poi_type": "Health and Wellness",
      "poi_address": "6555 W 119th St, Overland Park, KS 66209, USA",
      "poi_short_description": "Relaxed yoga studio offering a variety of classes including hot and restorative types, plus a shop selling yoga apparel.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019ff6b8-bbd0-77ad-a98f-e0bd73c5bb33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b8-bbd0-77ad-a98f-e0bd73c5bb33",
        "storage_key": "property/6767906449167599/019ff6b8-bbd0-77ad-a98f-e0bd73c5bb33.webp",
        "width": 554,
        "height": 312
      },
      "poi_business_url": "https://www.yogasix.com/overland-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4666487347789615135&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yogasix-overland-park",
      "poi_latitude": "38.9124848",
      "poi_longitude": "-94.6603913",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-660-9230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8fc6-7793-830c-d8e140afe810.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8fc6-7793-830c-d8e140afe810",
        "storage_key": "property/6767906449167599/019fc97a-8fc6-7793-830c-d8e140afe810.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkS5c-rTrwIcRH9DayYSxwkA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_136981f7-d97b-4ebf-82b7-f0ae485836ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Athletico Physical Therapy - Overland Park (135th-Metcalf)",
      "poi_type": "Health and Wellness",
      "poi_address": "7212 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01017-1045-7191-a0de-fef59c9cce4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-1045-7191-a0de-fef59c9cce4f",
        "storage_key": "property/6767906449167599/01a01017-1045-7191-a0de-fef59c9cce4f.webp",
        "width": 600,
        "height": 450
      },
      "poi_business_url": "https://www.athletico.com/locations/overland-park-135th-metcalf/?utm_source=google-overlandpark145th&utm_medium=web&utm_campaign=google-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=145277325410431053&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "athletico-physical-therapy---overland-park-135th-metcalf",
      "poi_latitude": "38.8841742",
      "poi_longitude": "-94.6693662",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-275-5343",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-908a-7033-ac8c-6933f453d6bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-908a-7033-ac8c-6933f453d6bf",
        "storage_key": "property/6767906449167599/019fc97a-908a-7033-ac8c-6933f453d6bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT-Nd1MnBwIcRTfABL_UgBAI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_5eee40e5-8c4d-4dda-9b1b-1f393effcfb2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Tomahawk Creek Trail and Indian Creek Trail Intersection",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11116 Brookwood St, Leawood, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01017-141a-73db-95ee-63a375d027da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-141a-73db-95ee-63a375d027da",
        "storage_key": "property/6767906449167599/01a01017-141a-73db-95ee-63a375d027da.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14811735291898927962&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tomahawk-creek-trail-and-indian-creek-trail-intersection",
      "poi_latitude": "38.9271949",
      "poi_longitude": "-94.6233817",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01017-2b9c-77b9-bb5b-5c69fb9995b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01017-2b9c-77b9-bb5b-5c69fb9995b0",
        "storage_key": "property/6767906449167599/01a01017-2b9c-77b9-bb5b-5c69fb9995b0.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJE8Sq4sTpwIcRWpvApMXajc0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_32647d5e-4f3f-4f9d-9b59-ab1e560ae513",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Yilan Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12601 Nall Ave, Leawood, KS 66209, USA",
      "poi_short_description": "Family-friendly park with a playground, picnic tables, walking trails, and shelters.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01017-0fcc-77bb-89c6-5f0611b90060.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-0fcc-77bb-89c6-5f0611b90060",
        "storage_key": "property/6767906449167599/01a01017-0fcc-77bb-89c6-5f0611b90060.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.leawood.org/facilities/facility/details/ILan-Park-11",
      "poi_directions_map_url": "https://maps.google.com/?cid=5345098373116711597&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yilan-park",
      "poi_latitude": "38.9010273",
      "poi_longitude": "-94.6478844",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-339-6700 ext. 151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-9037-7798-9509-fa26bcb0749c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-9037-7798-9509-fa26bcb0749c",
        "storage_key": "property/6767906449167599/019fc97a-9037-7798-9509-fa26bcb0749c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKfoEzQPqwIcRrdIjm6aaLUo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_74983a77-3465-4737-abe4-7242efcc8943",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Tomahawk Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3951 W 119th St, Leawood, KS 66209, USA",
      "poi_short_description": "Clean green space featuring swings, slides and trails, along with a baseball field.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01017-1100-731a-9248-657165b6cac4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-1100-731a-9248-657165b6cac4",
        "storage_key": "property/6767906449167599/01a01017-1100-731a-9248-657165b6cac4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.leawood.org/facilities/facility/details/Tomahawk-Park-8",
      "poi_directions_map_url": "https://maps.google.com/?cid=18086110426331874286&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tomahawk-park",
      "poi_latitude": "38.9106595",
      "poi_longitude": "-94.6336445",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-339-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-9037-7798-9509-fa26bcb0749c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-9037-7798-9509-fa26bcb0749c",
        "storage_key": "property/6767906449167599/019fc97a-9037-7798-9509-fa26bcb0749c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJTd8nBu7pwIcR7gMAwpvF_vo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7551221a-e714-4f6e-9612-fcb0f36b31cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Gezer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13251 Mission Rd, Leawood, KS 66209, USA",
      "poi_short_description": "Laid-back park with paved walking trails, a playground and a sandpit.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01017-1173-779e-ad1a-0d2e03fc4246.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-1173-779e-ad1a-0d2e03fc4246",
        "storage_key": "property/6767906449167599/01a01017-1173-779e-ad1a-0d2e03fc4246.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "https://www.leawood.org/facilities/facility/details/Gezer-Park-12",
      "poi_directions_map_url": "https://maps.google.com/?cid=6432708722736127620&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gezer-park",
      "poi_latitude": "38.8866337",
      "poi_longitude": "-94.6280323",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-663-9151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-9037-7798-9509-fa26bcb0749c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-9037-7798-9509-fa26bcb0749c",
        "storage_key": "property/6767906449167599/019fc97a-9037-7798-9509-fa26bcb0749c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJt2u6kw3CwIcRhF4-WoCSRVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8148fee3-107e-4af1-9f9e-6342a401f485",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Thomas S. Stoll Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12500 W 119th St, Overland Park, KS 66210, USA",
      "poi_short_description": "Public 79-acre park with 7 ball fields, a fishing lake, a playground & a scenic nature trail.",
      "poi_long_description": "Public 79-acre park with 7 ball fields, a fishing lake, a playground & a scenic nature trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97e-e733-725f-bd49-468d12a57eb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97e-e733-725f-bd49-468d12a57eb5",
        "storage_key": "property/6767906449167599/019fc97e-e733-725f-bd49-468d12a57eb5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.jcprd.com/parks_facilities/stoll_park.cfm",
      "poi_directions_map_url": "https://maps.google.com/?cid=11904290777782419563&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thomas-s-stoll-memorial-park",
      "poi_latitude": "38.9133269",
      "poi_longitude": "-94.7313061",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-438-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-9037-7798-9509-fa26bcb0749c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-9037-7798-9509-fa26bcb0749c",
        "storage_key": "property/6767906449167599/019fc97a-9037-7798-9509-fa26bcb0749c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ06uvXjSVwIcRawCuCGSJNKU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_95f1b14e-bbb7-46a1-a4c9-770de132ffe9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Ironwoods Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "14701 Mission Rd, Leawood, KS 66224, USA",
      "poi_short_description": "115-acre park featuring 4 cabins, a wooded walking trail, play equipment & a nature center.",
      "poi_long_description": "115-acre park featuring 4 cabins, a wooded walking trail, play equipment & a nature center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01017-14d5-7045-89d1-d209221d3727.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-14d5-7045-89d1-d209221d3727",
        "storage_key": "property/6767906449167599/01a01017-14d5-7045-89d1-d209221d3727.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.leawood.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=475632883990439650&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ironwoods-park",
      "poi_latitude": "38.8615834",
      "poi_longitude": "-94.6268024",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-339-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-9037-7798-9509-fa26bcb0749c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-9037-7798-9509-fa26bcb0749c",
        "storage_key": "property/6767906449167599/019fc97a-9037-7798-9509-fa26bcb0749c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJS_OgWTbCwIcR4qa-hZbJmQY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_681af855-dc6d-45af-8dc3-b6a1e4dcd7c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Leawoof Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "106th & Lee Boulevard, Leawood, KS 66211, USA",
      "poi_short_description": "Off-leash fenced-in, 2-area park offering agility equipment and water resources.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01017-1426-7543-9aea-a4d23a860380.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-1426-7543-9aea-a4d23a860380",
        "storage_key": "property/6767906449167599/01a01017-1426-7543-9aea-a4d23a860380.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.leawood.org/parks-and-recreation/parks-and-greenways/leawoof-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14151022259683570855&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "leawoof-dog-park",
      "poi_latitude": "38.9327052",
      "poi_longitude": "-94.6125895",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-663-9151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-9037-7798-9509-fa26bcb0749c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-9037-7798-9509-fa26bcb0749c",
        "storage_key": "property/6767906449167599/019fc97a-9037-7798-9509-fa26bcb0749c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_1CEy6XpwIcRp7QVFcWHYsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_f7cae45a-4a45-4fbb-90bc-398cc31b965d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "South Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7601 W 86th St, Overland Park, KS 66212, USA",
      "poi_short_description": "This 14-acre park features a playground, a trail, a fishing lake, basketball, restrooms & more.",
      "poi_long_description": "This 14-acre park features a playground, a trail, a fishing lake, basketball, restrooms & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01017-19b5-75f8-ad33-1fad2a3c4560.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-19b5-75f8-ad33-1fad2a3c4560",
        "storage_key": "property/6767906449167599/01a01017-19b5-75f8-ad33-1fad2a3c4560.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.opkansas.org/things-to-see-and-do/parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9828798773383756620&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-lake-park",
      "poi_latitude": "38.9725",
      "poi_longitude": "-94.6738889",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-9037-7798-9509-fa26bcb0749c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-9037-7798-9509-fa26bcb0749c",
        "storage_key": "property/6767906449167599/019fc97a-9037-7798-9509-fa26bcb0749c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdSu1Ko_rwIcRTHtVwGjoZog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e89ef958-0d57-4b0b-95c9-326983d44a93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Strang Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "West 88th and, Farley St, Overland Park, KS 66212, USA",
      "poi_short_description": "Relaxed playground-surrounded park featuring swings, basketball courts, and tennis courts along with a picnic shelter and a grill.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01017-19a2-7085-80fd-a2ba2a14c7dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-19a2-7085-80fd-a2ba2a14c7dc",
        "storage_key": "property/6767906449167599/01a01017-19a2-7085-80fd-a2ba2a14c7dc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.opkansas.org/park/strang-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3266416833072127371&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "strang-park",
      "poi_latitude": "38.9679845",
      "poi_longitude": "-94.699823",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-9037-7798-9509-fa26bcb0749c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-9037-7798-9509-fa26bcb0749c",
        "storage_key": "property/6767906449167599/019fc97a-9037-7798-9509-fa26bcb0749c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUYsGCWXrwIcRi92er82kVC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_785681fa-99db-45fd-b176-06b6cfc34ef7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Metcalf 127",
      "poi_type": "Shopping & Retail",
      "poi_address": "12607 Metcalf Ave, Overland Park, KS 66213, USA",
      "poi_short_description": "Shopping center hosting a row of eateries including Asian and Korean BBQ restaurants.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01017-1ab7-72cc-bbb5-d4b3548a1c95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-1ab7-72cc-bbb5-d4b3548a1c95",
        "storage_key": "property/6767906449167599/01a01017-1ab7-72cc-bbb5-d4b3548a1c95.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12113907166034178565&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "metcalf-127",
      "poi_latitude": "38.8995657",
      "poi_longitude": "-94.6667292",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8f65-73ca-b90e-d449312a7350.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8f65-73ca-b90e-d449312a7350",
        "storage_key": "property/6767906449167599/019fc97a-8f65-73ca-b90e-d449312a7350.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2Y40nnTqwIcRBbKGoWI-Hag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_b3b29344-9c24-43ee-95ac-fc29f10e2654",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Rosana Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "7500 W 119th St, Overland Park, KS 66213, USA",
      "poi_short_description": "Shopping center with a variety of stores and a large parking lot.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01017-1e55-75ea-9336-5d4e15831bb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-1e55-75ea-9336-5d4e15831bb6",
        "storage_key": "property/6767906449167599/01a01017-1e55-75ea-9336-5d4e15831bb6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16724846456080379668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rosana-square",
      "poi_latitude": "38.9151142",
      "poi_longitude": "-94.6741653",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8f65-73ca-b90e-d449312a7350.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8f65-73ca-b90e-d449312a7350",
        "storage_key": "property/6767906449167599/019fc97a-8f65-73ca-b90e-d449312a7350.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJT_5K7GnqwIcRFC-fYT2XGug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_0d292664-ca07-4614-9190-b0a4f096ed04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "75th and Metcalf Shopping Center via 635",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7527 Metcalf Ave, Overland Park, KS 66204, USA",
      "poi_short_description": "Business center offering a pharmacy and a variety of stores.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01017-1f7b-72aa-b133-d17ae2ee47ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-1f7b-72aa-b133-d17ae2ee47ed",
        "storage_key": "property/6767906449167599/01a01017-1f7b-72aa-b133-d17ae2ee47ed.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lane4group.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2506208036110720070&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "75th-and-metcalf-shopping-center-via-635",
      "poi_latitude": "38.9924392",
      "poi_longitude": "-94.666748",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 913-643-6330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-908a-7033-ac8c-6933f453d6bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-908a-7033-ac8c-6933f453d6bf",
        "storage_key": "property/6767906449167599/019fc97a-908a-7033-ac8c-6933f453d6bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2vXvWzswIcRRtybLe7WxyI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "custom_6c2ac702-db7b-43a0-ad46-1bf2bc703dc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Oak Park Mall Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16122160475460681538&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-park-mall-park--ride",
      "poi_latitude": "38.9552209",
      "poi_longitude": "-94.7216049",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97f-a368-70d1-99aa-e33ceb58e21f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97f-a368-70d1-99aa-e33ceb58e21f",
        "storage_key": "property/6767906449167599/019fc97f-a368-70d1-99aa-e33ceb58e21f.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJVwpg4UnrwIcRQj-tl4hrvd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_55e2b1d2-34a6-4782-8257-39a2ffd02b71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Mission Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "5251 Johnson Dr, Roeland Park, KS 66205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ridekc.org/locations/mission_transit_center",
      "poi_directions_map_url": "https://maps.google.com/?cid=14750820283784844061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-transit-center",
      "poi_latitude": "39.0229186",
      "poi_longitude": "-94.6460432",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97f-a368-70d1-99aa-e33ceb58e21f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97f-a368-70d1-99aa-e33ceb58e21f",
        "storage_key": "property/6767906449167599/019fc97f-a368-70d1-99aa-e33ceb58e21f.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0RGVf9XtwIcRHVOfGOVwtcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_48d1b5eb-c6de-438f-aa42-20c003c0acc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Heartland Community Church",
      "poi_type": "Transportation & Transit",
      "poi_address": "12175 S Strang Line Rd, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01017-1d87-73f6-9512-20954493bd25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-1d87-73f6-9512-20954493bd25",
        "storage_key": "property/6767906449167599/01a01017-1d87-73f6-9512-20954493bd25.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.heartlandchurch.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11439840584445010142&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heartland-community-church",
      "poi_latitude": "38.9077079",
      "poi_longitude": "-94.7721404",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 913-341-5820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01017-2b9e-70c8-b7ad-29fe5ec19b21.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01017-2b9e-70c8-b7ad-29fe5ec19b21",
        "storage_key": "property/6767906449167599/01a01017-2b9e-70c8-b7ad-29fe5ec19b21.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJtZEk2J6VwIcR3iDxkmZ6wp4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "custom_b6212da3-add0-4350-96db-ec6c27f11d2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Kansas City International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Kansas City Blvd, Kansas City, MO 64153, USA",
      "poi_short_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_long_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97f-3a05-712f-9d76-29ad7f687b47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97f-3a05-712f-9d76-29ad7f687b47",
        "storage_key": "property/6767906449167599/019fc97f-3a05-712f-9d76-29ad7f687b47.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.flykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14109162014977743520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-international-airport",
      "poi_latitude": "39.3014091",
      "poi_longitude": "-94.7104536",
      "poi_miles_from_property": "37.8",
      "poi_walking_minutes": "14 hours 6 mins",
      "poi_biking_minutes": "4 hours 5 mins",
      "poi_driving_minutes": "39 mins",
      "poi_business_phone": "+1 816-243-5237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-928c-7678-a5bd-da2764fb14b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-928c-7678-a5bd-da2764fb14b3",
        "storage_key": "property/6767906449167599/019fc97a-928c-7678-a5bd-da2764fb14b3.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYfmiAhewIcRoNouXRnQzcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_bb1b8fed-cd34-4a39-909e-6989a1d87b4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Overland Park Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "10500 Quivira Rd, Overland Park, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97e-6900-75cb-9e70-c917c6c64c1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97e-6900-75cb-9e70-c917c6c64c1a",
        "storage_key": "property/6767906449167599/019fc97e-6900-75cb-9e70-c917c6c64c1a.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.hcamidwest.com/locations/overland-park-regional-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13555409796355494155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-regional-medical-center",
      "poi_latitude": "38.9376197",
      "poi_longitude": "-94.7261812",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-541-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8f70-72d3-9bdd-f0591c9b2381.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8f70-72d3-9bdd-f0591c9b2381",
        "storage_key": "property/6767906449167599/019fc97a-8f70-72d3-9bdd-f0591c9b2381.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4cFCWJzAwIcRC5Ge4GN9Hrw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_ad777cc7-3244-4cd0-8e58-1f94fa4f214c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Children's Mercy Kansas",
      "poi_type": "Health and Wellness",
      "poi_address": "5808 W 110th St, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-45f7-7219-b8a1-a4f9a15b6e0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97a-45f7-7219-b8a1-a4f9a15b6e0f",
        "storage_key": "property/6767906449167599/019fc97a-45f7-7219-b8a1-a4f9a15b6e0f.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.childrensmercy.org/Kansas/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8535209985424805612&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-mercy-kansas",
      "poi_latitude": "38.9299718",
      "poi_longitude": "-94.6522904",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-696-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8f70-72d3-9bdd-f0591c9b2381.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8f70-72d3-9bdd-f0591c9b2381",
        "storage_key": "property/6767906449167599/019fc97a-8f70-72d3-9bdd-f0591c9b2381.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ03Xo8C7qwIcR7M6coEIoc3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_ec5e289a-1e07-4b04-a511-0e08df75e37e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Aspiria",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6140 Sprint Pkwy STE 125, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019ff6b8-c9d3-7728-9be3-35fedf4c7fdf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b8-c9d3-7728-9be3-35fedf4c7fdf",
        "storage_key": "property/6767906449167599/019ff6b8-c9d3-7728-9be3-35fedf4c7fdf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://aspiriakc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6433786320914474865&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aspiria",
      "poi_latitude": "38.9169728",
      "poi_longitude": "-94.6568885",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-285-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-908a-7033-ac8c-6933f453d6bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-908a-7033-ac8c-6933f453d6bf",
        "storage_key": "property/6767906449167599/019fc97a-908a-7033-ac8c-6933f453d6bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP0ZxsczrwIcRceffOpJmSVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_a09e917d-17b6-46e0-87ab-a0a0669e5928",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Black & Veatch",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11401 Lamar Ave, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97f-3ddc-7214-b7d9-1dc606dbae3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97f-3ddc-7214-b7d9-1dc606dbae3a",
        "storage_key": "property/6767906449167599/019fc97f-3ddc-7214-b7d9-1dc606dbae3a.webp",
        "width": 1280,
        "height": 653
      },
      "poi_business_url": "http://www.bv.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15245877116558125981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black--veatch",
      "poi_latitude": "38.9250015",
      "poi_longitude": "-94.6553624",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-458-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-908a-7033-ac8c-6933f453d6bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-908a-7033-ac8c-6933f453d6bf",
        "storage_key": "property/6767906449167599/019fc97a-908a-7033-ac8c-6933f453d6bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUyTe2TrqwIcRnSu0HXY8lNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_891cb09e-f96c-4e85-8741-6634d1c8af60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Blue Valley School District Office #229",
      "poi_type": "Major Employers & Offices",
      "poi_address": "15020 Metcalf Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bluevalleyk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12406361877646761667&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-valley-school-district-office-229",
      "poi_latitude": "38.8566433",
      "poi_longitude": "-94.6685552",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-239-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8fc6-7793-830c-d8e140afe810.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8fc6-7793-830c-d8e140afe810",
        "storage_key": "property/6767906449167599/019fc97a-8fc6-7793-830c-d8e140afe810.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkUYMDKHBwIcRw14VYGVALKw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_23147fa7-ce3b-4af7-8872-724d92d090cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "SMSD Center for Academic Achievement",
      "poi_type": "Education",
      "poi_address": "8200 W 71st St, Overland Park, KS 66204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01017-2427-7773-9961-12f8da5b7fcc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-2427-7773-9961-12f8da5b7fcc",
        "storage_key": "property/6767906449167599/01a01017-2427-7773-9961-12f8da5b7fcc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13529336476659713433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smsd-center-for-academic-achievement",
      "poi_latitude": "39.0014907",
      "poi_longitude": "-94.6802101",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 913-993-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-8fc6-7793-830c-d8e140afe810.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-8fc6-7793-830c-d8e140afe810",
        "storage_key": "property/6767906449167599/019fc97a-8fc6-7793-830c-d8e140afe810.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF9r8VFzswIcRmYUJEtjbwbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cfced1c5-c56b-4d6d-9078-bc90a96903bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Overland Park City Hall",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8500 Santa Fe Dr, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01017-23b2-727d-8401-56213e5bf3b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-23b2-727d-8401-56213e5bf3b6",
        "storage_key": "property/6767906449167599/01a01017-23b2-727d-8401-56213e5bf3b6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.opkansas.org/park/city-hall-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10640252352095117489&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-city-hall",
      "poi_latitude": "38.97448380000001",
      "poi_longitude": "-94.6854831",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-9037-7798-9509-fa26bcb0749c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-9037-7798-9509-fa26bcb0749c",
        "storage_key": "property/6767906449167599/019fc97a-9037-7798-9509-fa26bcb0749c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJmdh8t4HrwIcRseAkxyPFqZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_cb138a78-d279-4e3a-81d3-1b0cd8aa348f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "poi_name": "Corporate Woods Management Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9401 Indian Creek Pkwy #280, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.corporatewoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12669761914368547046&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corporate-woods-management-office",
      "poi_latitude": "38.9312568",
      "poi_longitude": "-94.6950429",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-451-4466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/019fc97a-908a-7033-ac8c-6933f453d6bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97a-908a-7033-ac8c-6933f453d6bf",
        "storage_key": "property/6767906449167599/019fc97a-908a-7033-ac8c-6933f453d6bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb4780vHrwIcR5ti1dlUJ1K8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "real_estate_agency"
    }
  ],
  "office_hours": [
    {
      "id": "ec_6be724a4bba0111274290401",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_fd700dbcfe7e80508fe6185e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_24e26dfc86cde08e343ded3b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_679c7b2f9e1affce810e409b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_01fb328b89d072ed355421ca",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_f3993bd01767a9d3f91a757d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_a180587a-438a-4a5c-a4cc-e95e1b7e99a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "rating": "5.0",
      "name": "John and Georgia Tucker",
      "text": "We are residents of Deer Creek Apartment homes and have been for a little over a year now.  We had a problem making our monthly payment on the resident portal. We talked to two members of the office staff and within a couple days they had graciously corrected our problem, that was our fault, and explained the problem to us so we could understand and handle it correctly the next time.  They were so helpful and kind in the way they handled our problem.  We are very happy to be residents at Deer Creek Apartment Homes.",
      "date": "2026-02-13",
      "title": ""
    },
    {
      "id": "custom_c6fd4824-6f64-4beb-8816-fabc0a1dbb44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "rating": "5.0",
      "name": "Shreyas Anand",
      "text": "One of the best apartments in Overland Park. Love this place. Very well built homes and good floor plans. The price is very competitive compared to places nearby with the same/lower quality. The staff is very courteous and quick to attend to any requests or complaints. The ambience inside the property is amazing especially with the trail next to the golf course. I would definitely recommend this place to anyone thinking of renting a place in Overland park.",
      "date": "2018-02-05",
      "title": ""
    },
    {
      "id": "custom_d4a023e9-ce2d-41a9-b3fb-840315c00666",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "rating": "4.0",
      "name": "Tracy Rice",
      "text": "The property is beautiful. The office staff is awesome. Love the pool and the strong community of residents that help each other. It’s amazing to have a garage too. Wonderful dog loving people and concierge that provides breakfast on Saturdays and events throughout the year. Just signed another year lease.\nGates provide a sense of security that I didn’t have in my last community and despite other reviews they do work 95% of the time.\n\nCons: cable is mandatory. Cable Customer service is poor because there is no competition. Since most people have to pay for streaming anyway, let them decide for themselves. Waste of money!\nSome Windows are old and not closing properly. They need to be replaced but am told they don’t make that window anymore so I have to get it approved. I have no idea how to do that. Air condition is not efficient and the utilities are high. $150 for thermostat set at 74 or 78 during summer.\n\nThat said…the pros outweigh the cons and it’s a wonderful place to live.",
      "date": "2023-07-27",
      "title": ""
    },
    {
      "id": "custom_3ee82023-6fbc-4be3-b9cc-9eca612b2a5b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "rating": "5",
      "name": "C Nettey",
      "text": "We just attended the halloween party yesterday and it was refreshing to see everyone come out -- young, old and in-between! My little man enjoyed the festivities and I also enjoyed getting to know the other residents. Thank you to Deer Creek for organizing these community events, and special shout out to Kristen, Eddie and Kofi for all their hard work with the guests! This was customer service at the highest level.\n",
      "date": "2026-11-01",
      "title": "false"
    },
    {
      "id": "custom_4036c3b4-2cc6-4613-bf33-ac4782f6da68",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "rating": "5",
      "name": "Hope Rainey",
      "text": "The speed from submitting the ticket to them fixing it was awesome very grateful for that\nThank you maintenance team!",
      "date": "2026-10-20",
      "title": "false"
    },
    {
      "id": "custom_14f07fbd-d59a-4605-a659-465ef6ea664a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "rating": "5",
      "name": "Brady Childs",
      "text": "Not sure the name of the maintenance man that helped me out but want to make sure he gets a thank you. Talked with him yesterday (Sunday) when he was helping out another unit, (he was not on the clock I believe). We needed a new air filter and couldn’t find one at the store. Spoke with him in the driveway of another unit and he was very friendly and made sure to let me know he will take care of it Monday as he was just stopping by to help out today. Sure enough calls me today at 11 and drops one off outside for my apartment just like he said the day before. It was hot as could be and I’m sure the last thing he wanted was another tenant coming with an issue (I know I would have lol), could not have been more professional and friendly. Not sure of his name but hopes he knows we appreciate his help - get that man a raise!!",
      "date": "2026-09-02",
      "title": "false"
    },
    {
      "id": "custom_dd6f4048-31fc-4c5f-8aac-d0327f091b49",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "rating": "5",
      "name": "David Jones",
      "text": "Very pleased with the fast response time to my maintenance request. I know the crew is stretched thin with the very hot weather air conditioning is most important . Job was done the next day. excellent job was done by all. Thank you!!\n",
      "date": "2026-08-30",
      "title": "false"
    },
    {
      "id": "custom_812fd9a0-a06c-4e39-8a94-1d73254927cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "rating": "5",
      "name": " Kay Elder",
      "text": "Kacey is absolutely the best property manager ever!!! She is very professional but very kind and helpful!!\n",
      "date": "2026-04-03",
      "title": "false"
    },
    {
      "id": "custom_a812d21d-d1ea-4f66-af43-854570ea6b0a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "rating": "5",
      "name": " John and Georgia Tucker",
      "text": "We are residents of Deer Creek Apartment homes and have been for a little over a year now. We had a problem making our monthly payment on the resident portal. We talked to two members of the office staff and within a couple days they had graciously corrected our problem, that was our fault, and explained the problem to us so we could understand and handle it correctly the next time. They were so helpful and kind in the way they handled our problem. We are very happy to be residents at Deer Creek Apartment Homes.",
      "date": "2026-04-03",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_2d57f49d57e845629a7513cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01026-4238-717d-a625-a5968e6da39f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01026-4238-717d-a625-a5968e6da39f",
        "storage_key": "property/6767906449167599/01a01026-4238-717d-a625-a5968e6da39f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A1 WRIGHT",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=36kVERJu29a"
    },
    {
      "id": "ec_8421f5f811c896e422174e08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01026-409c-7453-bde5-cfbdfd4c6604.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01026-409c-7453-bde5-cfbdfd4c6604",
        "storage_key": "property/6767906449167599/01a01026-409c-7453-bde5-cfbdfd4c6604.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A2 SUTTON",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=6yeVrieDhzV"
    },
    {
      "id": "ec_032a109b9081861d92fc8f12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01026-407a-76ee-9e47-011d4ea70679.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01026-407a-76ee-9e47-011d4ea70679",
        "storage_key": "property/6767906449167599/01a01026-407a-76ee-9e47-011d4ea70679.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A3 BRENTWOOD",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=VWRVVYhcLyt"
    },
    {
      "id": "ec_5d7e26803f0296ed466a4171",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01026-4115-7294-acfd-43251e45410b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01026-4115-7294-acfd-43251e45410b",
        "storage_key": "property/6767906449167599/01a01026-4115-7294-acfd-43251e45410b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A4 POWELL",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=jhFn8VFpQpP"
    },
    {
      "id": "ec_ffc621f41bda3a375cb0bcbe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01026-40b2-72ca-bb0e-c2a6200547bb.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01026-40b2-72ca-bb0e-c2a6200547bb",
        "storage_key": "property/6767906449167599/01a01026-40b2-72ca-bb0e-c2a6200547bb.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A5 PRAIRIE",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=NYgzGbypt59"
    },
    {
      "id": "ec_dc009701896d4558bbe559d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01026-4817-72a4-9fb1-cb1a65cfaa0b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01026-4817-72a4-9fb1-cb1a65cfaa0b",
        "storage_key": "property/6767906449167599/01a01026-4817-72a4-9fb1-cb1a65cfaa0b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "B1 WINSLOW",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=dtr4qkwGsMN"
    },
    {
      "id": "ec_c6f174039bd6d3420d1edb3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01026-479c-7269-af8b-060bc5a0d228.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01026-479c-7269-af8b-060bc5a0d228",
        "storage_key": "property/6767906449167599/01a01026-479c-7269-af8b-060bc5a0d228.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "B2 TALIESIN",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=7aUZ7j2hN49"
    },
    {
      "id": "ec_e7eed042814de87968056c3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01026-4711-72f9-b862-ece228717ba1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01026-4711-72f9-b862-ece228717ba1",
        "storage_key": "property/6767906449167599/01a01026-4711-72f9-b862-ece228717ba1.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "B3 ALLEN",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=CmG1GMhctFS"
    },
    {
      "id": "ec_5607ec2a92a55d176511cb5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167599/01a01026-477d-7091-ac33-4e87fe4283ed.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01026-477d-7091-ac33-4e87fe4283ed",
        "storage_key": "property/6767906449167599/01a01026-477d-7091-ac33-4e87fe4283ed.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "C1 LAURANT",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=KrSPECmFn4A"
    }
  ],
  "faqs": [
    {
      "id": "custom_195c7d94-6e9c-4bf2-bb06-06d30bfb5bb4",
      "question": "What are the qualifications for occupancy?",
      "answer": "Check our occupancy qualifications <a href=\"https://www.pricebrotherskc.com/ResidentialRentalQualifications/\">here</a>. We encourage everyone to apply, and hope to have you as a part of our community!",
      "category": "Rental Qualifications",
      "source": "custom"
    },
    {
      "id": "custom_3bf077f5-76f7-439b-abbd-89257732d13d",
      "question": "What is the application fee and is it refundable?",
      "answer": "Application fees are due for each person 18 and older occupying the apartment. All application fees are nonrefundable.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_1ba658ba-7bb7-4a71-b356-65cf7de4ba13",
      "question": "How do I apply?",
      "answer": "Click on the <a href=\"/apply-now\">Apply Now</a> button under the <a href=\"/floor-plans\">Floor Plans</a> tab of our community website.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_d6ddba1c-3b91-458b-8bcf-19ca3f7dd1c6",
      "question": "What is a holding deposit or earnest money?",
      "answer": "A \"holding\" deposit or \"earnest money\" is another word for \"security\" deposit. Please <a href=\"/contact-us\">contact our leasing office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_cde3ccc2-d69f-4da3-a99d-c58d442aac51",
      "question": "Are there different lease term options available?",
      "answer": "Yes, we offer various lease term options. Please <a href=\"/contact-us\">contact our office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_a55b0758-b328-4722-bc77-1f613e70acdc",
      "question": "Do I need an appointment to take a tour?",
      "answer": "No appointment is necessary to tour our community during business hours; however, it is always appreciated if you call ahead to make sure we are available to provide adequate time for you to tour and ask questions. It is recommended to arrive no later than one half hour prior to closing if you would like to tour the community. Everyone over 18 years of age must have a valid photo ID to tour. Valid forms of identification are decided by Price Brothers Management Company and may include items such as: US Driver’s License, US State Photo ID, US Military Photo ID, US Visa with Photo ID upon it, US Citizenship and Immigration Services Photo ID, Passport.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_4f2715e8-4e15-42f3-8cd3-ebd15d5483be",
      "question": "Do you allow pets?",
      "answer": "Our community is happy to accept cats and dogs. Please refer to our pet section on the <a href=\"/pet-policy\">Pet Policy</a> page.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_60fa52ad-5c8b-4723-acf7-0d116c67f17d",
      "question": "What utilities am I responsible to pay?",
      "answer": "Our residents are responsible to pay for electric, water, and trash.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_8a51819e-327c-4923-ae9f-bf8d1d022f0b",
      "question": "Why does your pricing include ranges?",
      "answer": "The prices will range on each floor plan depending on finishes, views, and other features inside the apartment home.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_e444fe95-915a-4e87-8b49-0b90fdcd15ff",
      "question": "Do you require renters insurance?",
      "answer": "All residents are required to maintain a minimum of $100,000 in liability coverage as part of their lease agreement. For more details on coverage requirements and available options, please <a href=\"/contact-us\">contact our leasing office</a>.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_f7c7df9a-cd6f-4fb5-b892-b7ce43417a59",
      "question": "How can I refer a friend?",
      "answer": "If you love living here and want to refer a friend, please let our office know! We offer resident referral programs throughout the year and would love for your friends and family to join our community.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_6b224470-bad7-4d66-af61-68eb0eecc0e4",
      "question": "How can I pay my rent?",
      "answer": "You can pay rent by accessing your <a href=\"/resident-access\">resident online account</a>. This allows you to use a bank account or credit card to make payments.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_97734811-c1b3-41d1-bc4a-0840319f5f17",
      "question": "Do you offer flexible rent payment options?",
      "answer": "Yes! We’ve partnered with Flex to make paying rent easier for our residents. Flex allows you to split your rent into smaller, more manageable payments throughout the month, giving you added financial flexibility. For more details or to sign up, <a href=\"/contact-us\">contact our leasing office</a> today!",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_72ebad99-211e-4ab9-8593-575450041007",
      "question": "Do you offer covered parking?",
      "answer": "Yes, we offer detached garages and attached garages on select apartment homes. Please <a href=\"/contact-us\">contact the leasing office</a> for pricing and availability.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_d796d2ec-b0a1-40b1-8183-fefbaca4da8f",
      "question": "Do you host events at your property?",
      "answer": "Yes, we host events throughout the year with various activities to encourage community camaraderie.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_5effa07e-13ae-4811-8786-399893315890",
      "question": "Do you accept packages on behalf of the residents?",
      "answer": "No, we do not offer this service at this time.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_9a12574d-195b-4b97-9c79-45a054472790",
      "question": "If something needs to be repaired in my apartment, how do I report it?",
      "answer": "You may call the office or submit work orders online by accessing your <a href=\"/resident-access\">resident account</a>. All emergency repairs should be reported by <a href=\"/contact-us\">contacting the office</a>. If the emergency is being reported after business hours, please follow the prompts to be connected to the answering service.",
      "category": "Maintenance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0c9ac-3713-71cc-b449-b93026ec0b31",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Deer Creek Apartment Homes Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599"
    },
    {
      "lead_collector_id": "01a0c9ac-378c-756f-b1ec-ca3257ade5fc",
      "lead_source": "LANDING_PAGE",
      "name": "Deer Creek Apartment Homes Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "page_item_url": "in-unit-laundry-apartments-overland-park",
      "search_query": "in-unit laundry apartments Overland Park",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Overland Park",
      "h2_subtitle": "Discover the ease of in-unit laundry in Overland Park. Enjoy modern living with convenient amenities at Deer Creek Apartment Homes.",
      "page_copy": "Experience the ultimate convenience at Deer Creek Apartment Homes with in-unit laundry that makes everyday life effortless. Situated in Overland Park, our craftsman-inspired community offers spacious one-, two-, and three-bedroom floor plans, each equipped with modern amenities designed to enhance your living experience.\n\nDeer Creek residents not only enjoy the benefits of in-unit laundry but also access to our resort-style amenities, such as a large garden tub and a main suite. Located in the inviting Deer Creek neighborhood, this is the perfect place to call home. Join us to see how seamlessly premium living and comfort blend together.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
      "featured_image_media": {
        "alt_text": "Indoor seating area with bar and tables, overlooking a swimming pool and lush greenery.",
        "public_id": "019fc97b-3704-77e7-bb7b-5cd1b715fe07",
        "storage_key": "property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apts Overland Park",
      "seo_description": "Explore Deer Creek with in-unit laundry in Overland Park. Embrace craftsman luxury with resort-style amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "page_item_url": "luxury-apartments-air-conditioning-johnson-county",
      "search_query": "luxury apartments with air conditioning in Johnson County",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with A/C in Johnson County",
      "h2_subtitle": "Enjoy luxury apartments with air conditioning in Johnson County. Discover the comfort and style at Deer Creek Apartment Homes.",
      "page_copy": "Discover the epitome of comfort and style at Deer Creek Apartment Homes in Johnson County. Our luxury apartments come equipped with air conditioning, ensuring a comfortable environment year-round. Nestled in the vibrant South Overland Park area, Deer Creek boasts craftsman-inspired designs paired with modern amenities such as expansive garden tubs, main suites, and controlled access for a premium living experience.\n\nOur community provides more than just a place to live—it's a lifestyle. Indulge in the convenience of a mud room and a fully equipped freezer, while our serene neighborhood offers a perfect retreat from the bustling city life. Schedule a tour today to explore how Deer Creek combines luxurious living with exceptional comfort in the heart of Johnson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
      "featured_image_media": {
        "alt_text": "Indoor seating area with bar and tables, overlooking a swimming pool and lush greenery.",
        "public_id": "019fc97b-3704-77e7-bb7b-5cd1b715fe07",
        "storage_key": "property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apts with A/C in Johnson County",
      "seo_description": "Explore Deer Creek's luxury apartments with air conditioning in Johnson County. Experience craftsman elegance with top-tier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "page_item_url": "deer-creek-apartments-private-balconies-patios",
      "search_query": "Deer Creek apartments with private balconies and patios",
      "category": "Amenity",
      "h1_title": "Deer Creek Apartments with Private Balconies",
      "h2_subtitle": "Relax in style on your private balcony at Deer Creek Apartments. Embrace outdoor living spaces in Overland Park.",
      "page_copy": "Welcome to Deer Creek Apartment Homes, where you can unwind in your own private balcony or patio. Located in Overland Park, our community offers an escape into nature right from your doorstep. Enjoy the comfort of craftsman-inspired living paired with the luxury of expansive outdoor spaces designed just for you.\n\nAt Deer Creek, our thoughtfully designed one-, two-, and three-bedroom apartment homes include modern amenities like a large garden tub, main suite, and controlled access for enhanced security. Situated in the picturesque Deer Creek neighborhood, you'll find the balance of serenity and convenience that makes calling our apartments home a joy. See it for yourself and indulge in the perfect blend of indoor and outdoor living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
      "featured_image_media": {
        "alt_text": "Indoor seating area with bar and tables, overlooking a swimming pool and lush greenery.",
        "public_id": "019fc97b-3704-77e7-bb7b-5cd1b715fe07",
        "storage_key": "property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Deer Creek Apts with Private Balconies",
      "seo_description": "Discover Deer Creek Apartments with private balconies and patios in Overland Park. Enjoy peaceful outdoor living in our luxury community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "page_item_url": "overland-park-apartments-modern-fitness-center",
      "search_query": "Overland Park apartments with modern fitness center",
      "category": "Amenity",
      "h1_title": "Overland Park Apts with Modern Fitness Center",
      "h2_subtitle": "Stay active at Overland Park apartments featuring a modern fitness center. Discover comfort and convenience at Deer Creek Apartment Homes.",
      "page_copy": "At Deer Creek Apartment Homes, located in the heart of Overland Park, you can maintain your active lifestyle with our state-of-the-art fitness center. Our luxury community combines craftsman-inspired designs with modern amenities to provide a seamless living experience. Whether you're working on cardio or strength training, our fitness center is equipped to meet all your needs.\n\nIn addition to the fitness center, Deer Creek offers an array of amenities such as spacious garden tubs, main suites, and controlled access for added peace of mind. Immerse yourself in the comfortable lifestyle of our one-, two-, and three-bedroom apartments, perfectly situated in the vibrant community of Deer Creek neighborhood. Schedule a tour today and explore all that Deer Creek has to offer!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
      "featured_image_media": {
        "alt_text": "Indoor seating area with bar and tables, overlooking a swimming pool and lush greenery.",
        "public_id": "019fc97b-3704-77e7-bb7b-5cd1b715fe07",
        "storage_key": "property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Overland Park Apartments with Modern Fitness Center",
      "seo_description": "Explore Deer Creek Apartments in Overland Park with a modern fitness center. Enjoy luxury living with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "page_item_url": "overland-park-apartments-resort-style-pool",
      "search_query": "apartments with resort-style pool in Overland Park KS",
      "category": "Amenity",
      "h1_title": "Apts in Overland Park with Resort-Style Pool",
      "h2_subtitle": "Dive into relaxation at our Overland Park apartments featuring a resort-style pool. Discover luxury living at Deer Creek Apartment Homes.",
      "page_copy": "Experience the best of Overland Park living at Deer Creek Apartment Homes, where luxury and leisure converge. Our community features a stunning resort-style pool, perfect for enjoying warm Kansas days. Whether you're lounging poolside or taking a refreshing swim, our pool offers a slice of paradise right at home.\n\nDeer Creek Apartment Homes offers more than just a beautiful pool. Our craftsman-inspired one-, two-, and three-bedroom apartments include modern amenities like spacious garden tubs, main suites, and controlled access. Nestled in the serene Deer Creek neighborhood, you'll appreciate the blend of relaxation and convenience that our community provides. Schedule a tour and see how Deer Creek redefines upscale living in Overland Park, KS.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
      "featured_image_media": {
        "alt_text": "Indoor seating area with bar and tables, overlooking a swimming pool and lush greenery.",
        "public_id": "019fc97b-3704-77e7-bb7b-5cd1b715fe07",
        "storage_key": "property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Resort-Style Pool in Overland Park",
      "seo_description": "Discover Deer Creek Apartments in Overland Park, KS with a resort-style pool and luxurious amenities. Experience the best in apartment living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-overland-park-ks",
      "search_query": "one bedroom apartments Overland Park KS",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Overland Park, KS",
      "h2_subtitle": "Find your perfect one-bedroom apartment in Overland Park, KS at Deer Creek Apartment Homes, where comfort meets style.",
      "page_copy": "Discover the ideal one-bedroom apartment at Deer Creek Apartment Homes in Overland Park, KS. Our craftsman-inspired designs offer a stylish and comfortable living experience, perfect for anyone seeking a refined home environment. Each apartment features a spacious layout with modern amenities such as a large garden tub, main suite, and controlled access, ensuring both luxury and convenience.\n\nLocated in the peaceful Deer Creek neighborhood, Deer Creek Apartment Homes provides residents with a balanced lifestyle of serenity and modern living. Our community's resort-style spaces, including a fitness center and pool, offer additional relaxation and recreation opportunities. Come tour our one-bedroom apartments today and see for yourself why Deer Creek is the place to call home in Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
      "featured_image_media": {
        "alt_text": "Indoor seating area with bar and tables, overlooking a swimming pool and lush greenery.",
        "public_id": "019fc97b-3704-77e7-bb7b-5cd1b715fe07",
        "storage_key": "property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Overland Park, KS",
      "seo_description": "Explore stylish one-bedroom apartments in Overland Park, KS at Deer Creek Apartment Homes. Experience luxury living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "page_item_url": "two-bedroom-apartment-homes-deer-creek",
      "search_query": "two bedroom apartment homes Deer Creek",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartment Homes in Deer Creek",
      "h2_subtitle": "Discover spacious two-bedroom apartment homes at Deer Creek with luxurious amenities and a serene environment in Overland Park.",
      "page_copy": "Explore the spacious two-bedroom apartment homes available at Deer Creek Apartment Homes, nestled in the tranquil Deer Creek neighborhood of Overland Park. Our meticulously designed apartments offer craftsman-inspired aesthetics paired with modern conveniences, creating an inviting and stylish living space.\n\nResidents enjoy an array of premium amenities, including large garden tubs and main suites, designed for ultimate comfort. Our community also features a resort-style pool and fitness center, catering to both relaxation and active lifestyles. With controlled access facilities, Deer Creek ensures peace of mind and a high standard of living. Schedule a tour of our two-bedroom homes today and experience elevated living in Overland Park's Deer Creek community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
      "featured_image_media": {
        "alt_text": "Indoor seating area with bar and tables, overlooking a swimming pool and lush greenery.",
        "public_id": "019fc97b-3704-77e7-bb7b-5cd1b715fe07",
        "storage_key": "property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartment Homes in Deer Creek",
      "seo_description": "Luxury two-bedroom apartment homes in Deer Creek, Overland Park. Enjoy spacious layouts and premium amenities at Deer Creek Apartment Homes.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "page_item_url": "three-bedroom-rentals-johnson-county",
      "search_query": "three bedroom rentals Johnson County",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Rentals in Johnson County",
      "h2_subtitle": "Discover Deer Creek Apartment Homes for spacious three bedroom rentals in Johnson County offering luxury and convenience.",
      "page_copy": "If you're seeking three-bedroom rentals in Johnson County, look no further than Deer Creek Apartment Homes. These expansive homes are perfectly suited for anyone seeking extra space. Emphasizing craftsman-inspired design, our three-bedroom apartments blend elegance with functionality, making them ideal for modern living.\n\nEach home at Deer Creek features high-end amenities such as main suites and garden tubs, designed to enhance your living experience. Located within the serene surroundings of the Deer Creek neighborhood, our community offers a resort-style pool and access-controlled facilities, ensuring a peaceful yet active lifestyle. Experience the best in contemporary living by scheduling a visit to view our three-bedroom apartment homes today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
      "featured_image_media": {
        "alt_text": "Indoor seating area with bar and tables, overlooking a swimming pool and lush greenery.",
        "public_id": "019fc97b-3704-77e7-bb7b-5cd1b715fe07",
        "storage_key": "property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Rentals in Johnson County",
      "seo_description": "Explore spacious three bedroom rentals in Johnson County at Deer Creek Apartment Homes. Enjoy luxury and convenience in our modern apartments.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "page_item_url": "apartment-homes-near-overland-trail-elementary",
      "search_query": "apartment homes near overland trail elementary school overland park",
      "category": "School",
      "h1_title": "Apartment Homes Near Overland Trail Elementary",
      "h2_subtitle": "Discover convenient apartment homes near Overland Trail Elementary in Overland Park.",
      "page_copy": "Conveniently located near Overland Trail Elementary School, Deer Creek Apartment Homes in Overland Park offer a welcoming community. Our one-, two-, and three-bedroom apartments provide craftsman-inspired comfort, ensuring a warm, inviting atmosphere for everyone. \n\nWith spacious layouts and amenities like garden tubs and main suites, Deer Creek Apartment Homes are designed for modern living. Additionally, our controlled access and resort-style amenities such as a pool and fitness center offer both security and recreation options. Choose Deer Creek for a balanced lifestyle close to Overland Trail Elementary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
      "featured_image_media": {
        "alt_text": "Indoor seating area with bar and tables, overlooking a swimming pool and lush greenery.",
        "public_id": "019fc97b-3704-77e7-bb7b-5cd1b715fe07",
        "storage_key": "property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Homes Near Overland Trail Elementary",
      "seo_description": "Find perfect apartment homes near Overland Trail Elementary in Overland Park at Deer Creek, with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "page_item_url": "deer-creek-apartments-near-overland-trail-middle",
      "search_query": "deer creek apartments close to overland trail middle school ks",
      "category": "School",
      "h1_title": "Deer Creek Apartments near Overland Trail Middle",
      "h2_subtitle": "Experience convenience at Deer Creek Apartments, located close to Overland Trail Middle School in Overland Park, KS.",
      "page_copy": "For those seeking a home near Overland Trail Middle School in Overland Park, KS, Deer Creek Apartment Homes provide an ideal location with exceptional living conditions. Our one-, two-, and three-bedroom apartments feature a craftsman-inspired design that combines style with comfort. \n\nResidents enjoy amenities such as garden tubs, main suites, and controlled access, ensuring both luxury and security. With its close proximity to Overland Trail Middle School, Deer Creek Apartments offer a community-oriented lifestyle. Discover the ease of living near great schools at Deer Creek Apartment Homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
      "featured_image_media": {
        "alt_text": "Indoor seating area with bar and tables, overlooking a swimming pool and lush greenery.",
        "public_id": "019fc97b-3704-77e7-bb7b-5cd1b715fe07",
        "storage_key": "property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Deer Creek Apartments near Overland Trail Middle",
      "seo_description": "Deer Creek Apartments offer modern living near Overland Trail Middle School in Overland Park, KS. Enjoy comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "page_item_url": "living-near-valley-park-elementary-johnson-county",
      "search_query": "living near valley park elementary school johnson county",
      "category": "School",
      "h1_title": "Living Near Valley Park Elementary School",
      "h2_subtitle": "Discover the benefits of living near Valley Park Elementary School in Johnson County at Deer Creek Apartment Homes.",
      "page_copy": "Located in the heart of Johnson County, Deer Creek Apartment Homes offers a prime living experience near Valley Park Elementary School. Our thoughtful community design and proximity to excellent schools make these homes a convenient choice.\n\nOur one-, two-, and three-bedroom apartments ensure both comfort and style, featuring amenities such as spacious garden tubs and modern main suites. Controlled access provides peace of mind while resort-style facilities promise leisure. Deer Creek Apartment Homes deliver convenience and quality for those looking to live near top educational institutions like Valley Park Elementary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
      "featured_image_media": {
        "alt_text": "Indoor seating area with bar and tables, overlooking a swimming pool and lush greenery.",
        "public_id": "019fc97b-3704-77e7-bb7b-5cd1b715fe07",
        "storage_key": "property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Valley Park Elementary School",
      "seo_description": "Enjoy living near Valley Park Elementary School in Johnson County at Deer Creek Apartments, offering comfortable and convenient homes.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "page_item_url": "apartments-near-blue-valley-north-high-school",
      "search_query": "apartments near blue valley north high school",
      "category": "School",
      "h1_title": "Apartments Near Blue Valley North High School",
      "h2_subtitle": "Find premium apartments near Blue Valley North High School at Deer Creek Apartment Homes, located in the vibrant Overland Park community.",
      "page_copy": "Deer Creek Apartment Homes offer an ideal location near Blue Valley North High School. Nestled in Overland Park, these apartments provide easy access to the school while offering comfortable and stylish living options ranging from one to three bedrooms. \n\nFeaturing spacious floor plans and top-notch amenities like large garden tubs and mudrooms, Deer Creek ensures a restful retreat at the end of the day. Its controlled access and welcoming community atmosphere make it a perfect choice for anyone prioritizing both security and convenience. Experience a well-rounded lifestyle near Blue Valley North High School at Deer Creek Apartment Homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
      "featured_image_media": {
        "alt_text": "Indoor seating area with bar and tables, overlooking a swimming pool and lush greenery.",
        "public_id": "019fc97b-3704-77e7-bb7b-5cd1b715fe07",
        "storage_key": "property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Blue Valley North High School",
      "seo_description": "Explore Deer Creek Apartments near Blue Valley North High School. Experience comfort and convenience in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "page_item_url": "overland-park-rentals-near-blue-valley-northwest",
      "search_query": "overland park rentals close to blue valley northwest high school",
      "category": "School",
      "h1_title": "Overland Park Rentals Near Blue Valley Northwest",
      "h2_subtitle": "Discover perfect rentals in Overland Park, close to Blue Valley Northwest High School, at Deer Creek Apartment Homes.",
      "page_copy": "Situated in Overland Park, Deer Creek Apartment Homes offer the ideal rental solution for those wanting to live close to Blue Valley Northwest High School. \n\nOur apartment homes feature spacious one-, two-, and three-bedroom layouts and are equipped with amenities like large garden tubs and controlled access for a luxurious yet secure living experience. With its location in a vibrant neighborhood, Deer Creek Apartment Homes provide both comfort and convenience, making it an excellent choice for anyone seeking a convenient home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
      "featured_image_media": {
        "alt_text": "Indoor seating area with bar and tables, overlooking a swimming pool and lush greenery.",
        "public_id": "019fc97b-3704-77e7-bb7b-5cd1b715fe07",
        "storage_key": "property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Overland Park Rentals Near Blue Valley Northwest HS",
      "seo_description": "Find Deer Creek rentals in Overland Park near Blue Valley Northwest High School. Enjoy convenient and comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "page_item_url": "deer-creek-apartments-near-johnson-county-college",
      "search_query": "deer creek apartment homes near johnson county community college",
      "category": "School",
      "h1_title": "Deer Creek Apartments Near JCCC",
      "h2_subtitle": "Explore the convenience of Deer Creek Apartment Homes, located near Johnson County Community College in Overland Park.",
      "page_copy": "Deer Creek Apartment Homes presents a premier living option in Overland Park, conveniently situated near Johnson County Community College. This prime location is perfect for students, faculty, and staff seeking a seamless blend of home and academic life.\n\nOur refined one-, two-, and three-bedroom apartments boast spacious interiors and modern amenities, such as large garden tubs and a dedicated mud room, ensuring both comfort and practicality. Enjoy the peace of mind with controlled access and indulge in our resort-style community offerings. Experience the ease of living near JCCC at the exquisite Deer Creek Apartment Homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
      "featured_image_media": {
        "alt_text": "Indoor seating area with bar and tables, overlooking a swimming pool and lush greenery.",
        "public_id": "019fc97b-3704-77e7-bb7b-5cd1b715fe07",
        "storage_key": "property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Deer Creek Apartments Near Johnson County Community College",
      "seo_description": "Live at Deer Creek Apartments near JCCC in Overland Park. Enjoy comfort and convenience in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "page_item_url": "apartments-near-overland-park-regional-medical",
      "search_query": "apartments near Overland Park Regional Medical Center",
      "category": "Hospital",
      "h1_title": "Apartments Near Overland Park Regional Medical",
      "h2_subtitle": "Find convenient apartments near Overland Park Regional Medical Center at Deer Creek Apartment Homes, offering comfort and style.",
      "page_copy": "Located in the heart of Overland Park, Deer Creek Apartment Homes offer an ideal living solution for anyone looking for apartments near Overland Park Regional Medical Center. Our polished apartment layouts are designed to meet the needs of those who value proximity and accessibility.\n\nWith a variety of one-, two-, and three-bedroom units, our apartments boast amenities like main suites and large garden tubs, ensuring comfort after a long day at the medical center. Deer Creek's controlled access and welcoming community atmosphere provide a secure and pleasant living experience. Discover the convenience of living near Overland Park Regional Medical Center at Deer Creek Apartment Homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
      "featured_image_media": {
        "alt_text": "Indoor seating area with bar and tables, overlooking a swimming pool and lush greenery.",
        "public_id": "019fc97b-3704-77e7-bb7b-5cd1b715fe07",
        "storage_key": "property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Overland Park Regional Medical",
      "seo_description": "Discover Deer Creek Apartments close to Overland Park Regional Medical Center. Comfort and convenience combined in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "page_item_url": "deer-creek-apts-near-childrens-mercy-kansas",
      "search_query": "Deer Creek Overland Park apartments by Children's Mercy Kansas",
      "category": "Hospital",
      "h1_title": "Deer Creek Apartments by Children's Mercy Kansas",
      "h2_subtitle": "Conveniently located near Children's Mercy Kansas, Deer Creek Overland Park Apartments offer a premium living experience.",
      "page_copy": "Deer Creek Apartment Homes are perfectly positioned near Children's Mercy Kansas, making it an excellent choice for anyone who wants to live close to the hospital. Our Overland Park apartments provide a comfortable and upscale living environment just moments from this leading pediatric facility.\n\nFeaturing spacious one-, two-, and three-bedroom layouts, residents enjoy modern amenities such as garden tubs and main suites for relaxation and comfort. Our community offers controlled access and a central location, enhancing safety and convenience. Experience refined living and quick access to Children's Mercy Kansas with Deer Creek Apartment Homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
      "featured_image_media": {
        "alt_text": "Indoor seating area with bar and tables, overlooking a swimming pool and lush greenery.",
        "public_id": "019fc97b-3704-77e7-bb7b-5cd1b715fe07",
        "storage_key": "property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Deer Creek Apartments by Children's Mercy Kansas",
      "seo_description": "Live near Children's Mercy Kansas at Deer Creek Overland Park Apartments. Enjoy luxury and proximity in our comfortable community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "page_item_url": "apartments-near-overland-park-arboretum-gardens",
      "search_query": "apartments near Overland Park Arboretum & Botanical Gardens",
      "category": "Park",
      "h1_title": "Apartments Near Overland Park Arboretum & Gardens",
      "h2_subtitle": "Discover serene apartments near the Overland Park Arboretum & Botanical Gardens, nestled in the heart of South Overland Park.",
      "page_copy": "Deer Creek Apartment Homes provides a tranquil living environment close to the lush landscapes of the Overland Park Arboretum & Botanical Gardens. Positioned in South Overland Park, our apartments are ideal for nature lovers who appreciate both convenience and serene living.\n\nOur one-, two-, and three-bedroom apartments combine craftsman-inspired designs with amenities like large garden tubs and mud rooms, offering both style and functionality. Residents benefit from controlled access and community-centric features, all while enjoying easy access to the beautiful arboretum and gardens nearby. Embrace the best of natural beauty and apartment living at Deer Creek Apartment Homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
      "featured_image_media": {
        "alt_text": "Indoor seating area with bar and tables, overlooking a swimming pool and lush greenery.",
        "public_id": "019fc97b-3704-77e7-bb7b-5cd1b715fe07",
        "storage_key": "property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Overland Park Arboretum & Gardens",
      "seo_description": "Find tranquility at Deer Creek Apartments near Overland Park Arboretum & Botanical Gardens. Enjoy nature and comfort in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "page_item_url": "rental-homes-close-to-yilan-park-overland-park",
      "search_query": "rental homes close to Yilan Park Overland Park",
      "category": "Park",
      "h1_title": "Rental Homes Close to Yilan Park Overland Park",
      "h2_subtitle": "Discover rental homes near Yilan Park in Overland Park. Deer Creek Apartment Homes offers the perfect blend of comfort and proximity.",
      "page_copy": "Deer Creek Apartment Homes offers a close-knit community of rental homes just a short distance from Yilan Park, a favored local destination in Overland Park. Whether you're looking for a peaceful jog or a family picnic, Yilan Park is easily accessible from our community, making it an ideal location for those who appreciate a blend of outdoor leisure and modern living.\n\nOur property features one-, two-, and three-bedroom units complete with modern amenities like main suites and freezers. Enjoy the serenity of controlled access and a beautifully maintained environment. Deer Creek is where comfort meets convenience, providing effortless access to Yilan Park and all that South Overland Park has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
      "featured_image_media": {
        "alt_text": "Indoor seating area with bar and tables, overlooking a swimming pool and lush greenery.",
        "public_id": "019fc97b-3704-77e7-bb7b-5cd1b715fe07",
        "storage_key": "property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Homes Close to Yilan Park Overland Park",
      "seo_description": "Explore Deer Creek's rental homes near Yilan Park Overland Park, offering comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "page_item_url": "deer-creek-apts-near-tomahawk-park-overland-park",
      "search_query": "Deer Creek apts near Tomahawk Park",
      "category": "Park",
      "h1_title": "Deer Creek Apts Near Tomahawk Park",
      "h2_subtitle": "Stay active with Deer Creek apartments near Tomahawk Park. Discover a lifestyle that combines convenience and recreation.",
      "page_copy": "Located a short distance from Tomahawk Park, Deer Creek Apartment Homes offers an exceptional living experience for those who value outdoor activities and community engagement. Our Overland Park location ensures that residents can enjoy the scenic trails, playgrounds, and picnicking areas of Tomahawk Park with ease.\n\nDeer Creek features craftsman-inspired one-, two-, and three-bedroom apartments, each designed with luxury and functionality in mind. Community amenities such as large garden tubs and a controlled access system ensure you live comfortably and securely. Choose Deer Creek Apartment Homes for thoughtful living spaces that perfectly complement the vibrant offerings of Tomahawk Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
      "featured_image_media": {
        "alt_text": "Indoor seating area with bar and tables, overlooking a swimming pool and lush greenery.",
        "public_id": "019fc97b-3704-77e7-bb7b-5cd1b715fe07",
        "storage_key": "property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Deer Creek Apts Near Tomahawk Park",
      "seo_description": "Live by Tomahawk Park at Deer Creek Apartments. Enjoy convenience, recreation, and comfort in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "page_item_url": "apartments-close-to-gezer-park-johnson-county",
      "search_query": "apartments close to Gezer Park Johnson County",
      "category": "Park",
      "h1_title": "Apartments Close to Gezer Park, Johnson County",
      "h2_subtitle": "Enjoy the ideal location in Johnson County with apartments near Gezer Park. Experience convenience and nature firsthand.",
      "page_copy": "Deer Creek Apartment Homes invites you to discover a blend of tranquility and accessibility with our apartments close to Gezer Park, Johnson County. Perfect for those who enjoy a connection with nature, Gezer Park offers lush greenery, walking trails, and cultural exhibits just moments from your doorstep.\n\nOur thoughtfully crafted one-, two-, and three-bedroom layouts are designed for comfort and style, featuring modern amenities like large garden tubs and spacious mud rooms. Positioned in the heart of Johnson County, Deer Creek provides an enviable lifestyle with the convenience of nearby recreational spaces like Gezer Park, ensuring you have everything you need to thrive right at home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
      "featured_image_media": {
        "alt_text": "Indoor seating area with bar and tables, overlooking a swimming pool and lush greenery.",
        "public_id": "019fc97b-3704-77e7-bb7b-5cd1b715fe07",
        "storage_key": "property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Gezer Park, Johnson County",
      "seo_description": "Find comfort at Deer Creek Apartments near Gezer Park, Johnson County. Enjoy nearby leisure and apartment luxury.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "page_item_url": "deer-creek-apartment-homes-near-thomas-stoll-memorial-park",
      "search_query": "Deer Creek Apartment Homes near Thomas S. Stoll Memorial Park",
      "category": "Park",
      "h1_title": "Deer Creek Apartments Near Thomas S. Stoll Park",
      "h2_subtitle": "Live near Thomas S. Stoll Memorial Park at Deer Creek. Enjoy a lifestyle filled with leisure and convenience in Overland Park.",
      "page_copy": "Nestled conveniently near Thomas S. Stoll Memorial Park, Deer Creek Apartment Homes offers a lifestyle enriched with opportunities for outdoor enjoyment in Overland Park. With spacious green landscapes and wonderful walking trails at Thomas S. Stoll Park, our residents have easy access to community and nature just around the corner.\n\nOur one-, two-, and three-bedroom apartments boast craftsman-inspired designs and modern conveniences like main suites and a controlled access system. Experience the perfect mix of resort-style amenities and nature-inspired living by choosing Deer Creek Apartment Homes. Just steps from a vibrant park, it’s easy to stay active and connected.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
      "featured_image_media": {
        "alt_text": "Indoor seating area with bar and tables, overlooking a swimming pool and lush greenery.",
        "public_id": "019fc97b-3704-77e7-bb7b-5cd1b715fe07",
        "storage_key": "property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Deer Creek Apartments Near Thomas S. Stoll Park",
      "seo_description": "Discover Deer Creek Apartments near Thomas S. Stoll Memorial Park. Enjoy Overland Park's blend of nature and luxury living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "page_item_url": "ironwoods-park-nearby-south-overland-park-rentals",
      "search_query": "Ironwoods Park nearby South Overland Park rentals",
      "category": "Park",
      "h1_title": "South Overland Park Rentals Near Ironwoods Park",
      "h2_subtitle": "Find your new home with rentals near Ironwoods Park. Enjoy South Overland Park's vibrant community and natural beauty every day.",
      "page_copy": "Discover the charm of Deer Creek Apartment Homes with its ideal location close to Ironwoods Park in South Overland Park. This vibrant area offers a serene setting for residents, with Ironwoods Park providing vast recreational areas, nature walks, and unique community events just a short drive away.\n\nDeer Creek Apartment Homes features a selection of finely appointed one-, two-, and three-bedroom apartments with luxurious amenities like mud rooms and large garden tubs. Embrace a seamless blend of nature and modern living with our well-serviced community spaces and convenient access to the scenic beauty of Ironwoods Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
      "featured_image_media": {
        "alt_text": "Indoor seating area with bar and tables, overlooking a swimming pool and lush greenery.",
        "public_id": "019fc97b-3704-77e7-bb7b-5cd1b715fe07",
        "storage_key": "property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Ironwoods Park in South Overland Park",
      "seo_description": "Explore South Overland Park rentals near Ironwoods Park at Deer Creek. Experience luxury living amidst natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "page_item_url": "leawoof-dog-park-overland-park-convenient-apartments",
      "search_query": "Leawoof Dog Park Overland Park convenient apartments",
      "category": "Park",
      "h1_title": "Convenient Apartments Near Leawoof Dog Park",
      "h2_subtitle": "Discover dog-friendly living near Leawoof Dog Park in Overland Park. Enjoy modern amenities and a welcoming community atmosphere.",
      "page_copy": "Deer Creek Apartment Homes presents an unparalleled living experience for pet lovers, situated conveniently near Leawoof Dog Park in Overland Park. This dedicated dog park is a local favorite, providing expansive spaces for your furry friends to romp and play, underlining the neighborhood's commitment to pet-friendly amenities.\n\nOur community offers one-, two-, and three-bedroom layouts that combine contemporary style with homey comforts, such as controlled access and generous main suites. Whether you're enjoying a lazy afternoon in your large garden tub or entertaining guests in our well-designed spaces, living near Leawoof Dog Park means you’re never far from fun and furry companionship.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
      "featured_image_media": {
        "alt_text": "Indoor seating area with bar and tables, overlooking a swimming pool and lush greenery.",
        "public_id": "019fc97b-3704-77e7-bb7b-5cd1b715fe07",
        "storage_key": "property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Convenient Apartments Near Leawoof Dog Park",
      "seo_description": "Find pet-friendly apartments near Leawoof Dog Park in Overland Park at Deer Creek. Experience comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "page_item_url": "apartments-close-to-south-lake-park-overland-park",
      "search_query": "apartments close to South Lake Park Overland Park",
      "category": "Park",
      "h1_title": "Apartments Close to South Lake Park",
      "h2_subtitle": "Experience serene living near South Lake Park in Overland Park. Enjoy the tranquility and convenience of nearby natural beauty.",
      "page_copy": "Living at Deer Creek Apartment Homes means you're just moments away from the tranquility of South Lake Park in Overland Park. This serene location provides an ideal backdrop for morning jogs, weekend picnics, or leisurely strolls around the expansive lake.\n\nDeer Creek offers a variety of apartment configurations, ensuring you find the perfect fit for your lifestyle. With features like large garden tubs and modern amenities, along with beautiful outdoor spaces, these apartments provide a peaceful retreat while keeping you close to the park's natural allure and the vibrant city life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
      "featured_image_media": {
        "alt_text": "Indoor seating area with bar and tables, overlooking a swimming pool and lush greenery.",
        "public_id": "019fc97b-3704-77e7-bb7b-5cd1b715fe07",
        "storage_key": "property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near South Lake Park Overland Park",
      "seo_description": "Explore Deer Creek Apartments near South Lake Park in Overland Park. Enjoy lush surroundings and modern comforts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "page_item_url": "strang-park-nearby-overland-park-apartment-living",
      "search_query": "Strang Park nearby Overland Park apartment living",
      "category": "Park",
      "h1_title": "Apartment Living Near Strang Park",
      "h2_subtitle": "Enjoy apartment living near Strang Park in Overland Park. Discover community amenities and a vibrant park nearby.",
      "page_copy": "Embrace the best of Overland Park apartment living at Deer Creek Apartment Homes, conveniently located near Strang Park. This charming green space offers recreational opportunities, from playgrounds and sports courts to peaceful areas for relaxation, perfect for weekend outings.\n\nDeer Creek features beautifully designed one-, two-, and three-bedroom apartments, providing luxurious amenities including mudrooms and controlled access. With the park close by, residents can effortlessly integrate outdoor fun into their daily lives. It's a perfect blend of suburban comfort and natural beauty, ensuring a lifestyle filled with convenience and enjoyment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
      "featured_image_media": {
        "alt_text": "Indoor seating area with bar and tables, overlooking a swimming pool and lush greenery.",
        "public_id": "019fc97b-3704-77e7-bb7b-5cd1b715fe07",
        "storage_key": "property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Overland Park Apartment Living by Strang Park",
      "seo_description": "Discover Deer Creek Apartments near Strang Park, offering convenient Overland Park living with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "page_item_url": "overland-park-city-hall-nearby-apartment-options",
      "search_query": "Overland Park City Hall nearby apartment options",
      "category": "Park",
      "h1_title": "Apartments Near Overland Park City Hall",
      "h2_subtitle": "Find apartment options near Overland Park City Hall. Enjoy proximity to civic amenities and vibrant community life.",
      "page_copy": "Deer Creek Apartment Homes offers convenient living options near Overland Park City Hall, placing you at the heart of the city's vibrant civic center. This prime location allows quick access to local government facilities, public services, and community events.\n\nOur spacious apartments boast a craftsman-inspired design, featuring luxurious amenities such as large garden tubs and freezer space. Whether you're working from home or commuting, having City Hall nearby enhances connectivity and access to the city's dynamic lifestyle, blending perfectly with our supportive community environment here at Deer Creek.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
      "featured_image_media": {
        "alt_text": "Indoor seating area with bar and tables, overlooking a swimming pool and lush greenery.",
        "public_id": "019fc97b-3704-77e7-bb7b-5cd1b715fe07",
        "storage_key": "property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Overland Park City Hall",
      "seo_description": "Explore Deer Creek Apartments near Overland Park City Hall, combining central convenience with modern living amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167599",
      "source": "custom",
      "page_item_url": "apartments-near-kansas-city-international-airport",
      "search_query": "apartments near kansas city international airport",
      "category": "Transit",
      "h1_title": "Apartments Near Kansas City Airport",
      "h2_subtitle": "Discover convenient apartment living near Kansas City International Airport. Enjoy easy travel access from Overland Park.",
      "page_copy": "For those seeking the convenience of living near Kansas City International Airport, consider Deer Creek Apartment Homes in Overland Park. Our location offers easy access to the airport, perfect for frequent flyers or professionals with travel-heavy schedules.\n\nDeer Creek combines modern living with resort-style amenities, featuring layouts from one to three bedrooms with perks like controlled access and spacious mud rooms. Right at the center of Johnson County, you’ll enjoy both the comfort of a well-appointed apartment and the convenience of being a short drive from the airport, making travel seamless and stress-free.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
      "featured_image_media": {
        "alt_text": "Indoor seating area with bar and tables, overlooking a swimming pool and lush greenery.",
        "public_id": "019fc97b-3704-77e7-bb7b-5cd1b715fe07",
        "storage_key": "property/6767906449167599/019fc97b-3704-77e7-bb7b-5cd1b715fe07.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kansas City International Airport",
      "seo_description": "Discover Deer Creek Apartments, conveniently located near Kansas City International Airport, offering perfect living for travelers.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12701861760"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MZZGNJZQ"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 6"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/47fca51e-6a2b-45f0-b56c-8b13be83ab8c/app.js?nocache=1&gaTracking=G-8GSWCGW6M8&buttonbgcolor=525437&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "913-357-5340"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ii9sMWU3WG5qRFVLRVVjUUJIQWpoMmc9PSIsInZhbHVlIjoiQ1BvQkxRTUE3NGw4M1B0RXZ3dzlyZz09IiwibWFjIjoiM2JiYjY4OGNjMGVkMzRmNTUzZGUxMWZlZWU2MzZjYTFjZWYzNmZjZmM5MjNmODhlY2Y1MzdlNzgyZTZhODIxNyJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12701861760",
  "custom_google_gtm_id": "GTM-MZZGNJZQ",
  "custom_rollout_phase": "Batch 6",
  "custom_vibesites_theme": "Preferred",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/47fca51e-6a2b-45f0-b56c-8b13be83ab8c/app.js?nocache=1&gaTracking=G-8GSWCGW6M8&buttonbgcolor=525437&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "913-357-5340",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ii9sMWU3WG5qRFVLRVVjUUJIQWpoMmc9PSIsInZhbHVlIjoiQ1BvQkxRTUE3NGw4M1B0RXZ3dzlyZz09IiwibWFjIjoiM2JiYjY4OGNjMGVkMzRmNTUzZGUxMWZlZWU2MzZjYTFjZWYzNmZjZmM5MjNmODhlY2Y1MzdlNzgyZTZhODIxNyJ9",
  "custom_audioeye_site_id": "7cabd1e9-f830-4d61-9018-1aad5dc0a543",
  "custom_audioeye_site_hash": "31e5b76ab07bfff64c52af4ff1df6cf8"
};

export const generatedAt = '2026-11-03T22:58:43.343Z';
